var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon122, _polygon123, _polygon124, _polygon125, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLumiasCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 980 1491.4",
    style: {
      enableBackground: "new 0 0 980 1491.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#101E42;}\r\n\t.st1{fill:#1B3066;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:#00F1FC;}\r\n\t.st5{enable-background:new    ;}\r\n\t.st6{fill:#01D2F5;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cards") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "card"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,3h846c66.3,0,120,53.7,120,120v1357.4l0,0H127c-66.3,0-120-53.7-120-120l0,0V3L7,3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1246.5 248.2,1246.2 490,1246 731.8,1246.2 852.7,1246.3 973.6,1246.5 852.7,1246.8 731.8,1246.8  490,1247 248.2,1246.8  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1258.8 248.2,1258.5 490,1258.3 731.8,1258.5 852.7,1258.6 973.6,1258.8 852.7,1259.1  731.8,1259.2 490,1259.3 248.2,1259.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1271.1 248.2,1270.8 490,1270.6 731.8,1270.8 852.7,1270.9 973.6,1271.1 852.7,1271.4  731.8,1271.5 490,1271.6 248.2,1271.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1283.4 248.2,1283.1 490,1282.9 731.8,1283.1 852.7,1283.2 973.6,1283.4 852.7,1283.7  731.8,1283.8 490,1283.9 248.2,1283.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1295.8 248.2,1295.4 490,1295.3 731.8,1295.4 852.7,1295.5 973.6,1295.8 852.7,1296 731.8,1296.1  490,1296.3 248.2,1296.1  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1308.1 248.2,1307.7 490,1307.6 731.8,1307.7 852.7,1307.8 973.6,1308.1 852.7,1308.3  731.8,1308.4 490,1308.6 248.2,1308.4  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1320.4 248.2,1320.1 490,1319.9 731.8,1320.1 852.7,1320.1 973.6,1320.4 852.7,1320.6  731.8,1320.7 490,1320.9 248.2,1320.7  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1332.7 248.2,1332.4 490,1332.2 731.8,1332.4 852.7,1332.4 973.6,1332.7 852.7,1332.9 731.8,1333  490,1333.2 248.2,1333  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1345 248.2,1344.7 490,1344.5 731.8,1344.7 852.7,1344.8 973.6,1345 852.7,1345.3 731.8,1345.3  490,1345.5 248.2,1345.3  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1357.3 248.2,1357 490,1356.8 731.8,1357 852.7,1357.1 973.6,1357.3 852.7,1357.6 731.8,1357.7  490,1357.8 248.2,1357.7  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1369.6 248.2,1369.3 490,1369.1 731.8,1369.3 852.7,1369.4 973.6,1369.6 852.7,1369.9 731.8,1370  490,1370.1 248.2,1370  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1381.9 248.2,1381.6 490,1381.4 731.8,1381.6 852.7,1381.7 973.6,1381.9 852.7,1382.2  731.8,1382.3 490,1382.4 248.2,1382.3  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1394.3 248.2,1393.9 490,1393.8 731.8,1393.9 852.7,1394 973.6,1394.3 852.7,1394.5 731.8,1394.6  490,1394.8 248.2,1394.6  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.4,1418.9 140.4,1418.6 259.5,1418.6 497.5,1418.4 735.6,1418.6 854.6,1418.6 973.6,1418.9  854.6,1419.1 735.6,1419.2 497.5,1419.4 259.5,1419.2 140.4,1419.1  "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.4,1443.5 157.1,1443.3 273.7,1443.2 507,1443 740.3,1443.2 857,1443.3 973.6,1443.5 857,1443.8  740.3,1443.8 507,1444 273.7,1443.8 157.1,1443.8  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.4,1406.6 136.1,1406.3 255.7,1406.2 495,1406.1 734.3,1406.2 854,1406.3 973.6,1406.6 854,1406.8  734.3,1406.9 495,1407.1 255.7,1406.9 136.1,1406.8  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "30.4,1431.2 148.3,1430.9 266.2,1430.9 502,1430.7 737.8,1430.9 855.7,1430.9 973.6,1431.2  855.7,1431.4 737.8,1431.5 502,1431.7 266.2,1431.5 148.3,1431.4  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.4,1455.8 168.4,1455.6 283.5,1455.5 513.5,1455.3 743.6,1455.5 858.6,1455.6 973.6,1455.8  858.6,1456.1 743.6,1456.2 513.5,1456.3 283.5,1456.2 168.4,1456.1  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "74.4,1468.1 186.8,1467.9 299.2,1467.8 524,1467.6 748.8,1467.8 861.2,1467.9 973.6,1468.1  861.2,1468.4 748.8,1468.5 524,1468.6 299.2,1468.5 186.8,1468.4  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.4,1480.4 207.8,1480.2 317.2,1480.1 536,1479.9 754.8,1480.1 864.2,1480.2 973.6,1480.4  864.2,1480.7 754.8,1480.8 536,1480.9 317.2,1480.8 207.8,1480.7  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,914.1 248.2,913.8 490,913.6 731.8,913.8 852.7,913.8 973.6,914.1 852.7,914.3 731.8,914.4  490,914.6 248.2,914.4  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,951 248.2,950.7 490,950.5 731.8,950.7 852.7,950.8 973.6,951 852.7,951.3 731.8,951.4 490,951.5  248.2,951.4  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,963.3 248.2,963 490,962.8 731.8,963 852.7,963.1 973.6,963.3 852.7,963.6 731.8,963.7 490,963.8  248.2,963.7  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,988 248.2,987.6 490,987.5 731.8,987.6 852.7,987.7 973.6,988 852.7,988.2 731.8,988.3 490,988.5  248.2,988.3  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1012.6 248.2,1012.3 490,1012.1 731.8,1012.3 852.7,1012.3 973.6,1012.6 852.7,1012.8  731.8,1012.9 490,1013.1 248.2,1012.9  "
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1049.5 248.2,1049.2 490,1049 731.8,1049.2 852.7,1049.3 973.6,1049.5 852.7,1049.8 731.8,1049.9  490,1050 248.2,1049.8  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1061.8 248.2,1061.5 490,1061.3 731.8,1061.5 852.7,1061.6 973.6,1061.8 852.7,1062.1  731.8,1062.2 490,1062.3 248.2,1062.2  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1086.5 248.2,1086.1 490,1086 731.8,1086.1 852.7,1086.2 973.6,1086.5 852.7,1086.7 731.8,1086.8  490,1087 248.2,1086.8  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1111.1 248.2,1110.8 490,1110.6 731.8,1110.8 852.7,1110.8 973.6,1111.1 852.7,1111.3  731.8,1111.4 490,1111.6 248.2,1111.4  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1135.7 248.2,1135.4 490,1135.2 731.8,1135.4 852.7,1135.5 973.6,1135.7 852.7,1135.9 731.8,1136  490,1136.2 248.2,1136  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1160.3 248.2,1160 490,1159.8 731.8,1160 852.7,1160.1 973.6,1160.3 852.7,1160.6 731.8,1160.7  490,1160.8 248.2,1160.7  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1184.9 248.2,1184.6 490,1184.4 731.8,1184.6 852.7,1184.7 973.6,1184.9 852.7,1185.2  731.8,1185.3 490,1185.4 248.2,1185.3  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1197.3 248.2,1196.9 490,1196.8 731.8,1196.9 852.7,1197 973.6,1197.3 852.7,1197.5 731.8,1197.6  490,1197.8 248.2,1197.6  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1209.6 248.2,1209.3 490,1209.1 731.8,1209.3 852.7,1209.3 973.6,1209.6 852.7,1209.8  731.8,1209.9 490,1210.1 248.2,1209.9  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1221.9 248.2,1221.6 490,1221.4 731.8,1221.6 852.7,1221.7 973.6,1221.9 852.7,1222.1  731.8,1222.2 490,1222.4 248.2,1222.2  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1234.2 248.2,1233.9 490,1233.7 731.8,1233.9 852.7,1234 973.6,1234.2 852.7,1234.4 731.8,1234.5  490,1234.7 248.2,1234.5  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,520.1 248.2,519.8 490,519.6 731.8,519.8 852.7,519.9 973.6,520.1 852.7,520.3 731.8,520.4  490,520.6 248.2,520.4  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,557 248.2,556.7 490,556.5 731.8,556.7 852.7,556.8 973.6,557 852.7,557.3 731.8,557.4 490,557.5  248.2,557.4  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,569.3 248.2,569 490,568.8 731.8,569 852.7,569.1 973.6,569.3 852.7,569.6 731.8,569.7 490,569.8  248.2,569.7  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,594 248.2,593.7 490,593.5 731.8,593.6 852.7,593.7 973.6,594 852.7,594.2 731.8,594.3 490,594.5  248.2,594.3  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,618.6 248.2,618.3 490,618.1 731.8,618.3 852.7,618.4 973.6,618.6 852.7,618.8 731.8,618.9  490,619.1 248.2,618.9  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,655.5 248.2,655.2 490,655 731.8,655.2 852.7,655.3 973.6,655.5 852.7,655.8 731.8,655.9 490,656  248.2,655.9  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,667.8 248.2,667.5 490,667.3 731.8,667.5 852.7,667.6 973.6,667.8 852.7,668.1 731.8,668.2  490,668.3 248.2,668.2  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,692.5 248.2,692.1 490,692 731.8,692.1 852.7,692.2 973.6,692.5 852.7,692.7 731.8,692.8 490,693  248.2,692.8  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,704.8 248.2,704.5 490,704.3 731.8,704.5 852.7,704.5 973.6,704.8 852.7,705 731.8,705.1  490,705.3 248.2,705.1  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,717.1 248.2,716.8 490,716.6 731.8,716.8 852.7,716.8 973.6,717.1 852.7,717.3 731.8,717.4  490,717.6 248.2,717.4  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,741.7 248.2,741.4 490,741.2 731.8,741.4 852.7,741.5 973.6,741.7 852.7,742 731.8,742 490,742.2  248.2,742  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,766.3 248.2,766 490,765.8 731.8,766 852.7,766.1 973.6,766.3 852.7,766.6 731.8,766.7 490,766.8  248.2,766.7  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,791 248.2,790.6 490,790.5 731.8,790.6 852.7,790.7 973.6,791 852.7,791.2 731.8,791.3 490,791.5  248.2,791.3  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,815.6 248.2,815.3 490,815.1 731.8,815.3 852.7,815.3 973.6,815.6 852.7,815.8 731.8,815.9  490,816.1 248.2,815.9  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,840.2 248.2,839.9 490,839.7 731.8,839.9 852.7,840 973.6,840.2 852.7,840.5 731.8,840.5  490,840.7 248.2,840.5  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,864.8 248.2,864.5 490,864.3 731.8,864.5 852.7,864.6 973.6,864.8 852.7,865.1 731.8,865.2  490,865.3 248.2,865.2  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1098.8 248.2,1098.4 490,1098.3 731.8,1098.4 852.7,1098.5 973.6,1098.8 852.7,1099 731.8,1099.1  490,1099.3 248.2,1099.1  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1123.4 248.2,1123.1 490,1122.9 731.8,1123.1 852.7,1123.2 973.6,1123.4 852.7,1123.6  731.8,1123.7 490,1123.9 248.2,1123.7  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1148 248.2,1147.7 490,1147.5 731.8,1147.7 852.7,1147.8 973.6,1148 852.7,1148.3 731.8,1148.3  490,1148.5 248.2,1148.3  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1172.6 248.2,1172.3 490,1172.1 731.8,1172.3 852.7,1172.4 973.6,1172.6 852.7,1172.9 731.8,1173  490,1173.1 248.2,1173  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,729.4 248.2,729.1 490,728.9 731.8,729.1 852.7,729.2 973.6,729.4 852.7,729.7 731.8,729.7  490,729.9 248.2,729.7  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,754 248.2,753.7 490,753.5 731.8,753.7 852.7,753.8 973.6,754 852.7,754.3 731.8,754.4 490,754.5  248.2,754.4  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,778.7 248.2,778.3 490,778.2 731.8,778.3 852.7,778.4 973.6,778.7 852.7,778.9 731.8,779  490,779.2 248.2,779  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,803.3 248.2,803 490,802.8 731.8,803 852.7,803 973.6,803.3 852.7,803.5 731.8,803.6 490,803.8  248.2,803.6  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,827.9 248.2,827.6 490,827.4 731.8,827.6 852.7,827.7 973.6,827.9 852.7,828.2 731.8,828.2  490,828.4 248.2,828.2  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,852.5 248.2,852.2 490,852 731.8,852.2 852.7,852.3 973.6,852.5 852.7,852.8 731.8,852.9 490,853  248.2,852.9  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,877.2 248.2,876.8 490,876.7 731.8,876.8 852.7,876.9 973.6,877.2 852.7,877.4 731.8,877.5  490,877.7 248.2,877.5  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,889.5 248.2,889.1 490,889 731.8,889.1 852.7,889.2 973.6,889.5 852.7,889.7 731.8,889.8 490,890  248.2,889.8  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,901.8 248.2,901.5 490,901.3 731.8,901.5 852.7,901.5 973.6,901.8 852.7,902 731.8,902.1  490,902.3 248.2,902.1  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,926.4 248.2,926.1 490,925.9 731.8,926.1 852.7,926.2 973.6,926.4 852.7,926.7 731.8,926.7  490,926.9 248.2,926.7  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,938.7 248.2,938.4 490,938.2 731.8,938.4 852.7,938.5 973.6,938.7 852.7,939 731.8,939 490,939.2  248.2,939  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,975.7 248.2,975.3 490,975.2 731.8,975.3 852.7,975.4 973.6,975.7 852.7,975.9 731.8,976  490,976.2 248.2,976  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1000.3 248.2,999.9 490,999.8 731.8,999.9 852.7,1000 973.6,1000.3 852.7,1000.5 731.8,1000.6  490,1000.8 248.2,1000.6  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1024.9 248.2,1024.6 490,1024.4 731.8,1024.6 852.7,1024.7 973.6,1024.9 852.7,1025.1  731.8,1025.2 490,1025.4 248.2,1025.2  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1037.2 248.2,1036.9 490,1036.7 731.8,1036.9 852.7,1037 973.6,1037.2 852.7,1037.4 731.8,1037.5  490,1037.7 248.2,1037.5  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,1074.2 248.2,1073.8 490,1073.7 731.8,1073.8 852.7,1073.9 973.6,1074.2 852.7,1074.4  731.8,1074.5 490,1074.6 248.2,1074.5  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,532.4 248.2,532.1 490,531.9 731.8,532.1 852.7,532.2 973.6,532.4 852.7,532.7 731.8,532.8  490,532.9 248.2,532.8  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,544.7 248.2,544.4 490,544.2 731.8,544.4 852.7,544.5 973.6,544.7 852.7,545 731.8,545.1  490,545.2 248.2,545.1  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,581.7 248.2,581.3 490,581.2 731.8,581.3 852.7,581.4 973.6,581.7 852.7,581.9 731.8,582  490,582.2 248.2,582  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,606.3 248.2,606 490,605.8 731.8,606 852.7,606 973.6,606.3 852.7,606.5 731.8,606.6 490,606.8  248.2,606.6  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,630.9 248.2,630.6 490,630.4 731.8,630.6 852.7,630.7 973.6,630.9 852.7,631.2 731.8,631.3  490,631.4 248.2,631.2  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,643.2 248.2,642.9 490,642.7 731.8,642.9 852.7,643 973.6,643.2 852.7,643.5 731.8,643.6  490,643.7 248.2,643.6  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,680.2 248.2,679.8 490,679.7 731.8,679.8 852.7,679.9 973.6,680.2 852.7,680.4 731.8,680.5  490,680.7 248.2,680.5  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,323.1 248.2,322.8 490,322.6 731.8,322.8 852.7,322.9 973.6,323.1 852.7,323.4 731.8,323.4  490,323.6 248.2,323.4  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,335.4 248.2,335.1 490,334.9 731.8,335.1 852.7,335.2 973.6,335.4 852.7,335.7 731.8,335.8  490,335.9 248.2,335.8  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,347.7 248.2,347.4 490,347.2 731.8,347.4 852.7,347.5 973.6,347.7 852.7,348 731.8,348.1  490,348.2 248.2,348.1  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,360 248.2,359.7 490,359.5 731.8,359.7 852.7,359.8 973.6,360 852.7,360.3 731.8,360.4 490,360.5  248.2,360.4  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,372.4 248.2,372 490,371.9 731.8,372 852.7,372.1 973.6,372.4 852.7,372.6 731.8,372.7 490,372.9  248.2,372.7  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,384.7 248.2,384.3 490,384.2 731.8,384.3 852.7,384.4 973.6,384.7 852.7,384.9 731.8,385  490,385.2 248.2,385  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,397 248.2,396.6 490,396.5 731.8,396.6 852.7,396.7 973.6,397 852.7,397.2 731.8,397.3 490,397.5  248.2,397.3  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,409.3 248.2,409 490,408.8 731.8,409 852.7,409 973.6,409.3 852.7,409.5 731.8,409.6 490,409.8  248.2,409.6  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,421.6 248.2,421.3 490,421.1 731.8,421.3 852.7,421.4 973.6,421.6 852.7,421.9 731.8,421.9  490,422.1 248.2,421.9  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,433.9 248.2,433.6 490,433.4 731.8,433.6 852.7,433.7 973.6,433.9 852.7,434.2 731.8,434.3  490,434.4 248.2,434.3  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,446.2 248.2,445.9 490,445.7 731.8,445.9 852.7,446 973.6,446.2 852.7,446.5 731.8,446.6  490,446.7 248.2,446.6  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,458.5 248.2,458.2 490,458 731.8,458.2 852.7,458.3 973.6,458.5 852.7,458.8 731.8,458.9 490,459  248.2,458.9  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,470.9 248.2,470.5 490,470.4 731.8,470.5 852.7,470.6 973.6,470.9 852.7,471.1 731.8,471.2  490,471.4 248.2,471.2  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,483.2 248.2,482.8 490,482.7 731.8,482.8 852.7,482.9 973.6,483.2 852.7,483.4 731.8,483.5  490,483.7 248.2,483.5  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,495.5 248.2,495.1 490,495 731.8,495.1 852.7,495.2 973.6,495.5 852.7,495.7 731.8,495.8 490,496  248.2,495.8  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,507.8 248.2,507.5 490,507.3 731.8,507.5 852.7,507.5 973.6,507.8 852.7,508 731.8,508.1  490,508.3 248.2,508.1  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,261.5 248.2,261.2 490,261 731.8,261.2 852.7,261.3 973.6,261.5 852.7,261.8 731.8,261.9 490,262  248.2,261.9  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,273.9 248.2,273.5 490,273.4 731.8,273.5 852.7,273.6 973.6,273.9 852.7,274.1 731.8,274.2  490,274.4 248.2,274.2  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,286.2 248.2,285.9 490,285.7 731.8,285.8 852.7,285.9 973.6,286.2 852.7,286.4 731.8,286.5  490,286.7 248.2,286.5  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,298.5 248.2,298.2 490,298 731.8,298.2 852.7,298.2 973.6,298.5 852.7,298.7 731.8,298.8 490,299  248.2,298.8  "
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,310.8 248.2,310.5 490,310.3 731.8,310.5 852.7,310.6 973.6,310.8 852.7,311 731.8,311.1  490,311.3 248.2,311.1  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,64.6 125.4,64.3 244.5,64.2 482.5,64.1 720.6,64.2 839.6,64.3 958.6,64.6 839.6,64.8 720.6,64.9  482.5,65.1 244.5,64.9 125.4,64.8  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,76.9 126.1,76.6 245.7,76.5 485,76.4 724.3,76.5 844,76.6 963.6,76.9 844,77.1 724.3,77.2  485,77.4 245.7,77.2 126.1,77.1  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,89.2 246.7,88.8 487,88.7 727.3,88.8 847.5,88.9 967.6,89.2 847.5,89.4 727.3,89.5 487,89.7  246.7,89.5  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,101.5 248.2,101.2 490,101 731.8,101.2 852.7,101.3 973.6,101.5 852.7,101.7 731.8,101.8 490,102  248.2,101.8  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,113.8 248.2,113.5 490,113.3 731.8,113.5 852.7,113.6 973.6,113.8 852.7,114.1 731.8,114.1  490,114.3 248.2,114.1  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,126.1 248.2,125.8 490,125.6 731.8,125.8 852.7,125.9 973.6,126.1 852.7,126.4 731.8,126.4  490,126.6 248.2,126.4  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,15.3 118.9,15.1 231.5,15 456.5,14.8 681.6,15 794.1,15.1 906.6,15.3 794.1,15.6 681.6,15.6  456.5,15.8 231.5,15.6 118.9,15.6  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,3 114.9,2.8 223.5,2.7 440.5,2.5 657.6,2.7 766.1,2.8 874.6,3 766.1,3.2 657.6,3.3 440.5,3.5  223.5,3.3 114.9,3.2  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,27.6 121.3,27.4 236.2,27.3 466,27.1 695.8,27.3 810.7,27.4 925.6,27.6 810.7,27.9 695.8,28  466,28.1 236.2,28 121.3,27.9  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,39.9 123.1,39.7 239.7,39.6 473,39.4 706.3,39.6 823,39.7 939.6,39.9 823,40.2 706.3,40.3  473,40.4 239.7,40.3 123.1,40.2  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,52.3 124.4,52 242.5,51.9 478.5,51.8 714.6,51.9 832.6,52 950.6,52.3 832.6,52.5 714.6,52.6  478.5,52.8 242.5,52.6 124.4,52.5  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,138.4 248.2,138.1 490,137.9 731.8,138.1 852.7,138.2 973.6,138.4 852.7,138.7 731.8,138.8  490,138.9 248.2,138.8  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,150.7 248.2,150.4 490,150.3 731.8,150.4 852.7,150.5 973.6,150.7 852.7,151 731.8,151.1  490,151.2 248.2,151.1  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,163.1 248.2,162.7 490,162.6 731.8,162.7 852.7,162.8 973.6,163.1 852.7,163.3 731.8,163.4  490,163.6 248.2,163.4  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,175.4 248.2,175 490,174.9 731.8,175 852.7,175.1 973.6,175.4 852.7,175.6 731.8,175.7 490,175.9  248.2,175.7  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,187.7 248.2,187.4 490,187.2 731.8,187.4 852.7,187.4 973.6,187.7 852.7,187.9 731.8,188  490,188.2 248.2,188  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,200 248.2,199.7 490,199.5 731.8,199.7 852.7,199.8 973.6,200 852.7,200.2 731.8,200.3 490,200.5  248.2,200.3  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,212.3 248.2,212 490,211.8 731.8,212 852.7,212.1 973.6,212.3 852.7,212.6 731.8,212.6 490,212.8  248.2,212.6  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,224.6 248.2,224.3 490,224.1 731.8,224.3 852.7,224.4 973.6,224.6 852.7,224.9 731.8,224.9  490,225.1 248.2,224.9  "
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,236.9 248.2,236.6 490,236.4 731.8,236.6 852.7,236.7 973.6,236.9 852.7,237.2 731.8,237.3  490,237.4 248.2,237.3  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.4,249.2 248.2,248.9 490,248.7 731.8,248.9 852.7,249 973.6,249.2 852.7,249.5 731.8,249.6  490,249.7 248.2,249.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.7225,
    y1: 398.9775,
    x2: 889.3174,
    y2: 1197.5825,
    gradientTransform: "matrix(1 0 0 -1 0 1492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A172FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#987AFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#808FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#58B1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#30D4D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#4ABDDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#729BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#8A86F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#937EFA"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 294.4,
    className: "st2",
    width: 798.6,
    height: 798.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -90.6645,
    y1: 165.6206,
    x2: 1070.6646,
    y2: 1326.9395,
    gradientTransform: "matrix(1 0 0 -1 0 1492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A172FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#987AFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#808FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#58B1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#30D4D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#4ABDDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#729BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#8A86F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#937EFA"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M853,0H7C3.1,0,0,3.1,0,7v1357.4c0,70.1,56.9,127,127,127l0,0h846c3.9,0,7-3.1,7-7V127C980,56.9,923.1,0,853,0 z M966,1477.4H713.4c-1.5,0-3-0.6-4.1-1.6l-10.1-9.2c-4.4-4.1-10.2-6.3-16.2-6.3H297c-6,0-11.8,2.3-16.2,6.3l-10.1,9.2 c-1.1,1-2.6,1.6-4.1,1.6H127c-62.4,0-113-50.6-113-113V24.8h439.8c4,0,7.9-1,11.4-2.9l13.3-7.2c0.9-0.5,1.9-0.7,2.9-0.7H853 c62.4,0,113,50.6,113,113V1477.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M906.4,277.3v832.8H73.6V277.3H906.4 M908.4,275.3H71.6v836.8h836.8V275.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M908.4,1196.6H71.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h836.8c0.6,0,1,0.4,1,1S909,1196.6,908.4,1196.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M908.4,1354H71.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h836.8c0.6,0,1,0.4,1,1S909,1354,908.4,1354z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.2,1289.8l-4.8,4.8c-4.1,4.1-10.7,4.1-14.7,0l-20.3-20.3l1.6-1.6c3.1-3.1,8.2-3.2,11.3-0.1 c0,0,0,0,0.1,0.1l18.7,18.7l4.8-4.8l-18.7-18.7c-5.8-5.8-15.1-5.8-20.9,0l-6.4,6.4l25.1,25.1c6.7,6.7,17.6,6.7,24.3,0l4.8-4.8 c3.1-3.1,8.2-3.2,11.3-0.1c0,0,0,0,0.1,0.1l0.9,0.9l-12.1,12.1c-2.8,2.8-7.3,3.2-10.5,0.9c-3,0.6-6,0.8-9.1,0.7l3.2,3.2 c5.8,5.8,15.3,5.8,21.1,0l16.9-16.9l-5.7-5.7C166.3,1284,157,1284,151.2,1289.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.6,1258.8l4.8-4.8c4.1-4.1,10.7-4.1,14.7,0l20.3,20.3l-1.6,1.6c-3.1,3.1-8.2,3.2-11.3,0.1c0,0,0,0-0.1-0.1 l-18.7-18.7l-4.7,4.8l18.7,18.7c5.8,5.8,15.1,5.8,20.9,0l6.4-6.4l-25.1-25.1c-6.7-6.7-17.6-6.7-24.3,0l-4.8,4.8 c-3.1,3.1-8.2,3.1-11.4,0l-0.9-0.9l12.1-12.1c2.8-2.8,7.3-3.2,10.5-0.9c3-0.6,6-0.8,9.1-0.7l-3.2-3.2c-5.8-5.8-15.3-5.8-21.1,0 l-16.8,16.8l5.7,5.7C134.5,1264.6,143.8,1264.6,149.6,1258.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.1,1354H71.6c-0.6,0-1-0.4-1-1v-157.5c0-0.6,0.4-1,1-1h157.5c0.6,0,1,0.4,1,1V1353 C230.1,1353.6,229.7,1354,229.1,1354z M72.6,1352h155.5v-155.5H72.6V1352z"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "71.6,1353.1 94.4,1353.1 71.6,1330.3  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.1,1353.1 229.1,1330.3 206.4,1353.1  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.1,1195.6 206.4,1195.6 229.1,1218.3  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "71.6,1195.6 71.6,1218.3 94.4,1195.6  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lumias-skin"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M830.6,1265.2l-3.8,18h13.8v8h-15.5l-4.3,20h-8.7l4.3-20h-21l-4.3,20h-8.7l4.3-20H771v-8h17.4l3.8-18h-15.5 v-8h17.2l4.3-20h8.7l-4.3,20h21l4.3-20h8.7l-4.3,20h13.9v8H830.6z M821.9,1265.2h-21l-3.8,18h21L821.9,1265.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M854.4,1254.1v-15.9h27.7v73h-17.8v-57.1H854.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.3,168.8h16.6v11.4H88.4v-53.6h14.9V168.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.8,126.6v31.1c0,2.9,0.7,5.1,2,6.7c1.3,1.6,3.4,2.4,6.1,2.4s4.8-0.8,6.2-2.4c1.4-1.6,2.1-3.8,2.1-6.7 v-31.1h14.9v31.1c0,4.9-1,9.1-3.1,12.6c-2.1,3.5-4.9,6.1-8.5,7.8c-3.6,1.7-7.5,2.6-11.9,2.6c-4.4,0-8.2-0.9-11.7-2.6 c-3.4-1.7-6.1-4.3-8.1-7.8c-2-3.4-2.9-7.7-2.9-12.6v-31.1H141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M245.4,126.6v53.6h-14.9v-29.6l-10.1,29.6h-12.5l-10.2-29.8v29.8h-14.9v-53.6h18l13.5,34.8l13.1-34.8H245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M270.3,126.6v53.6h-14.9v-53.6H270.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M314.2,171.4h-19l-2.9,8.7h-15.7l19.5-53.6h17.2l19.5,53.6h-15.7L314.2,171.4z M310.5,160l-5.8-17.3L299,160 H310.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.1,176.2c-4-3-6.2-7.2-6.5-12.7h15.9c0.2,1.9,0.7,3.2,1.7,4.1c1,0.9,2.2,1.3,3.7,1.3c1.4,0,2.5-0.3,3.4-1 c0.9-0.7,1.3-1.6,1.3-2.8c0-1.6-0.7-2.8-2.2-3.6c-1.5-0.9-3.9-1.8-7.1-2.9c-3.5-1.2-6.3-2.3-8.5-3.4c-2.2-1.1-4-2.7-5.6-4.8 c-1.6-2.1-2.4-4.9-2.4-8.2c0-3.4,0.9-6.4,2.6-8.9c1.7-2.5,4.1-4.3,7.1-5.6s6.5-1.9,10.3-1.9c6.2,0,11.2,1.5,14.9,4.4 c3.7,2.9,5.7,7,6,12.3h-16.2c-0.1-1.6-0.5-2.8-1.5-3.6c-0.9-0.8-2.1-1.2-3.6-1.2c-1.1,0-2,0.3-2.7,1c-0.7,0.7-1.1,1.6-1.1,2.8 c0,1,0.4,1.9,1.2,2.6c0.8,0.7,1.8,1.4,2.9,1.9c1.2,0.5,2.9,1.2,5.2,2c3.4,1.2,6.2,2.3,8.4,3.5c2.2,1.1,4.1,2.7,5.7,4.8 c1.6,2.1,2.4,4.6,2.4,7.8c0,3.2-0.8,6.1-2.4,8.6c-1.6,2.5-3.9,4.5-6.9,6c-3,1.5-6.6,2.2-10.7,2.2 C353.2,180.7,348.1,179.2,344.1,176.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,629.5l-7.3,7.3l7.3,7.2c1,1,2.7,1,3.7,0l7.3-7.2l-7.3-7.3C325.7,628.5,324,628.5,323,629.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,569.5l-7.3,7.2l7.3,7.2c1,1,2.7,1,3.7,0c0,0,0,0,0,0l7.3-7.2l-7.3-7.2C325.7,568.5,324,568.5,323,569.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,599.5l-7.3,7.2l7.3,7.2c1,1,2.7,1,3.7,0l7.3-7.3l-7.3-7.2C325.7,598.5,324,598.5,323,599.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.4,861.4c-5.2,0.4-9.9,5.1-13.1,12.4c4.2,1.6,8.6,2.5,13.1,2.5V861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,659.5l-7.3,7.2l7.3,7.3c1,1,2.7,1,3.7,0l7.3-7.2l-7.3-7.2C325.7,658.5,324.1,658.5,323,659.5 C323,659.5,323,659.5,323,659.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,719.5l-7.3,7.2l7.3,7.3c1,1,2.7,1,3.7,0l7.3-7.3l-7.3-7.2C325.7,718.5,324,718.5,323,719.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.9,1008.3h-1.9v-20.2c0-0.9,0.5-1.8,1.3-2.2l19-11l0.9,1.6l55.5-32v-82.7l-121.2-70 c-0.2-0.1-0.4-0.4-0.4-0.6V588.4h-1.8v-78.1h1.9v-27.1l-49.8-28.8v386.4h1.9v78.1h-1.9v152.9h47.5V970c-1.4-0.4-2.2-1.9-1.7-3.2 s1.9-2.2,3.2-1.7s2.2,1.9,1.7,3.2c-0.2,0.8-0.9,1.5-1.7,1.7v101.8h47.5V1008.3z M274.6,926.9L274.6,926.9 c-16.3-13.1-18.9-36.7-5.8-52.9c1.7-2.1,3.6-4.1,5.8-5.8l0.1-0.1c5.1-4.1,11.2-6.8,17.8-7.8h0.1c0.5-0.1,0.9-0.1,1.4-0.2l0.7-0.1 h0.6l1.3-0.1h0.4h1.4c0.5,0,1,0,1.4,0h0.3l1.3,0.1h0.6l0.7,0.1l1.4,0.2h0.1c6.5,1,12.6,3.7,17.8,7.8l0.1,0.1 c16.2,13,18.8,36.7,5.8,52.9c-1.7,2.1-3.6,4.1-5.8,5.8l-0.1,0.1c-5.1,4.1-11.2,6.8-17.8,7.8h-0.2c-0.4,0.1-0.9,0.1-1.3,0.2 l-0.7,0.1l-0.6,0l-1.3,0.1h-0.3c-0.5,0-0.9,0-1.4,0h-1.4h-0.4l-1.3-0.1l-0.6,0l-0.7-0.1c-0.5,0-0.9-0.1-1.3-0.2h-0.2 C285.8,933.8,279.7,931.1,274.6,926.9L274.6,926.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.2,315.7h-42.7v133.2c1.4,0.3,2.3,1.7,1.9,3.1c-0.3,1.1-1.3,2-2.5,2v54.7l43.2,25L155.2,315.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "383.8,946.2 329.1,977.8 330,979.4 312.3,989.7 312.3,1008.3 310.4,1008.3 310.4,1071.8 310.4,1071.8  383.8,1071.8 383.8,1071.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,689.5l-7.3,7.2l7.3,7.3c1,1,2.7,1,3.7,0c0,0,0,0,0,0l7.3-7.2l-7.3-7.2C325.7,688.5,324,688.5,323,689.5 C323,689.5,323,689.5,323,689.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M594.8,734.9h-1.8V634.3l-24.5-14.1l0.9-1.6l-79.7-46c-0.2-0.1-0.4-0.4-0.4-0.6V315.7h-51.5v302.5 c1.4,0.3,2.3,1.7,2,3.1c-0.3,1.4-1.7,2.3-3.1,2s-2.3-1.7-2-3.1c0.2-1,1-1.8,2-2V315.7h-51.5v336.9h1.9v100.6l24.5,14.2l-0.9,1.6 l79.7,46c0.2,0.1,0.4,0.4,0.4,0.6v256.2h104L594.8,734.9z M504.2,744.8c-7.8,7.8-20.5,7.8-28.4,0l-4.3-4.3 c4.1,0.2,8.2-0.1,12.2-0.9c4.4,3.1,10.3,2.6,14.1-1.2l16.2-16.3l-1.3-1.3c-4.2-4.2-11.1-4.2-15.3,0l-6.5,6.5c-9,9-23.6,9-32.6,0 l-33.7-33.7l8.6-8.6c7.8-7.7,20.3-7.7,28.1,0l25.1,25.2l-6.4,6.4L455,691.6c-4.2-4.2-11.1-4.2-15.3,0l-2.2,2.2l27.3,27.3 c5.5,5.5,14.3,5.5,19.8,0c0,0,0,0,0,0l6.5-6.5c7.8-7.7,20.3-7.7,28.1,0l7.7,7.7L504.2,744.8z M542.8,1061.6c-0.9,0-1.6-0.7-1.6-1.6 c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0C544.4,1060.8,543.7,1061.6,542.8,1061.6L542.8,1061.6z M542.8,1048.1 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0C544.4,1047.4,543.7,1048.1,542.8,1048.1L542.8,1048.1z  M542.8,1034.7c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,1034,543.7,1034.7,542.8,1034.7L542.8,1034.7z  M542.8,1021.3c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,1020.5,543.7,1021.3,542.8,1021.3L542.8,1021.3z  M542.8,1007.8c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0 C544.4,1007.1,543.7,1007.8,542.8,1007.8L542.8,1007.8z M542.8,994.4c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6 c0,0,0,0,0,0C544.4,993.7,543.7,994.4,542.8,994.4L542.8,994.4z M542.8,980.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6 s1.6,0.7,1.6,1.6l0,0C544.4,980.2,543.7,980.9,542.8,980.9L542.8,980.9z M542.8,967.5c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6 s1.6,0.7,1.6,1.6l0,0C544.4,966.8,543.7,967.5,542.8,967.5L542.8,967.5z M542.8,954.1c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6 s1.6,0.7,1.6,1.6l0,0C544.4,953.3,543.7,954.1,542.8,954.1L542.8,954.1z M542.8,940.6c-0.9,0-1.6-0.7-1.6-1.6 c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0C544.4,939.9,543.7,940.6,542.8,940.6L542.8,940.6z M542.8,927.2 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6c0,0,0,0,0,0C544.4,926.5,543.7,927.2,542.8,927.2L542.8,927.2z  M542.8,913.8c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,913,543.7,913.7,542.8,913.8L542.8,913.8z  M542.8,900.3c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,899.6,543.7,900.3,542.8,900.3L542.8,900.3z  M542.8,886.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,886.1,543.7,886.9,542.8,886.9L542.8,886.9z  M542.8,873.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0 C544.4,872.7,543.7,873.4,542.8,873.4L542.8,873.4z M542.8,860c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6 c0,0,0,0,0,0C544.4,859.3,543.7,860,542.8,860L542.8,860z M542.8,846.6c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6 l0,0C544.4,845.8,543.7,846.6,542.8,846.6L542.8,846.6z M542.8,833.1c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0 C544.4,832.4,543.7,833.1,542.8,833.1L542.8,833.1z M542.8,819.7c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 c0.9,0,1.6,0.7,1.6,1.6c0,0,0,0,0,0C544.4,819,543.7,819.7,542.8,819.7L542.8,819.7z M542.8,806.3c-0.9,0-1.6-0.7-1.6-1.6 s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6c0,0,0,0,0,0C544.4,805.5,543.7,806.2,542.8,806.3L542.8,806.3z M542.8,792.8 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,792.1,543.7,792.8,542.8,792.8L542.8,792.8z M542.8,779.4 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C544.4,778.6,543.7,779.4,542.8,779.4L542.8,779.4z M546.8,702.3 c-7.8,7.7-20.3,7.7-28.1,0l-25.2-25.2l6.4-6.4l25.1,25.1c4.2,4.2,11.1,4.2,15.3,0l2.2-2.2l-27.3-27.3c-5.5-5.5-14.3-5.5-19.8,0 c0,0,0,0,0,0l-6.5,6.5c-7.8,7.7-20.3,7.7-28.1,0l-7.7-7.7l22.7-22.7c7.8-7.8,20.5-7.8,28.4,0l4.3,4.3c-4.1-0.2-8.2,0.1-12.2,0.9 c-4.4-3.1-10.4-2.6-14.1,1.2L466,665.3l1.3,1.3c4.2,4.2,11.1,4.2,15.3,0c0,0,0,0,0,0l6.5-6.5c9-9,23.6-9,32.6,0l33.7,33.7 L546.8,702.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640,386.8l4.7,0.9c0.3,0.1,0.5,0.3,0.6,0.6c0.8,3.9,2.3,7.7,4.6,11c0.2,0.3,0.2,0.6,0,0.8l-2.7,4 c-0.5,0.8-0.4,1.8,0.2,2.5l3.2,3.2c0.7,0.7,1.7,0.8,2.5,0.2l4-2.7c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1 c3.3,2.3,7.1,3.8,11,4.6c0.3,0.1,0.5,0.3,0.6,0.6l0.9,4.8c0.2,0.9,1,1.5,1.9,1.6h4.6c0.9,0,1.7-0.7,1.9-1.6l0.9-4.8 c0-0.3,0.3-0.5,0.6-0.6c3.9-0.8,7.7-2.3,11-4.6c0.3-0.2,0.6-0.2,0.8,0l4,2.7c0.8,0.5,1.8,0.4,2.5-0.2l3.2-3.2 c0.7-0.7,0.7-1.7,0.2-2.5l-2.7-4c-0.2-0.3-0.2-0.6,0-0.8c2.3-3.3,3.8-7.1,4.6-11c0.1-0.3,0.3-0.5,0.6-0.6l4.8-0.9 c0.9-0.2,1.6-1,1.6-1.9v-4.6c0-0.9-0.7-1.7-1.6-1.9l-4.8-0.9c-0.3-0.1-0.5-0.3-0.6-0.6c-0.8-3.9-2.3-7.7-4.6-11 c-0.2-0.3-0.2-0.6,0-0.8l2.7-4c0.5-0.8,0.4-1.8-0.2-2.5l-3.2-3.2c-0.7-0.7-1.7-0.8-2.5-0.2l-4,2.7c-0.3,0.2-0.6,0.2-0.8,0 c-3.3-2.3-7.1-3.8-11-4.6c-0.3-0.1-0.5-0.3-0.6-0.6l-0.9-4.8c-0.2-0.9-1-1.6-1.9-1.6h-4.6c-0.9,0-1.7,0.7-1.9,1.6l-0.9,4.8 c-0.1,0.3-0.3,0.5-0.6,0.6c-3.9,0.8-7.7,2.3-11,4.6c-0.3,0.2-0.6,0.2-0.8,0l-4-2.7c-0.8-0.5-1.8-0.4-2.5,0.2l-3.2,3.2 c-0.6,0.7-0.7,1.7-0.2,2.5l2.7,4c0.2,0.3,0.2,0.6,0,0.8c-2.3,3.3-3.8,7.1-4.6,11c-0.1,0.3-0.3,0.5-0.6,0.6l-4.7,0.9 c-0.9,0.2-1.6,1-1.6,1.9v4.6C638.4,385.8,639.1,386.6,640,386.8z M674.6,368.1c8,0,14.5,6.5,14.5,14.5c0,8-6.5,14.5-14.5,14.5 c-8,0-14.5-6.5-14.5-14.5c0,0,0,0,0,0C660.1,374.6,666.6,368.1,674.6,368.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M674.6,395.6c7.2,0,13-5.8,13-13s-5.8-13-13-13s-13,5.8-13,13S667.4,395.6,674.6,395.6L674.6,395.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "155.2,535.4 112,510.4 112,662.5 155.2,637.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,479.6l-7.3,7.3l7.3,7.2c1,1,2.7,1,3.7,0l7.3-7.2l-7.3-7.3C325.7,478.6,324,478.6,323,479.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,509.6l-7.3,7.2l7.3,7.2c1,1,2.7,1,3.7,0l7.3-7.2l-7.3-7.2C325.7,508.6,324,508.6,323,509.6 C323,509.6,323,509.6,323,509.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "312.3,379.1 312.3,397.8 330,408 329.1,409.6 383.8,441.2 383.8,315.7 310.4,315.7 310.4,379.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.3,816L410,770.2l-0.9,1.6l-25.8-14.9c-0.8-0.5-1.3-1.3-1.3-2.2V652.5h1.8V442.9l-55.5-32l-0.9,1.6l-19-11 c-0.8-0.5-1.3-1.3-1.3-2.2v-20.2h1.9v-63.4h-47.6v101.8c1.4,0.4,2.1,1.8,1.7,3.2c-0.4,1.4-1.8,2.1-3.2,1.7s-2.1-1.8-1.7-3.2 c0.2-0.8,0.9-1.5,1.7-1.7V315.7h-47.5v137l51,29.4c0.2,0.1,0.4,0.4,0.4,0.6v27.5h1.9v78.1h-1.9v182.5l121.2,70 c0.2,0.1,0.4,0.4,0.4,0.6v230.3h51.5v-227c-1.4-0.3-2.3-1.7-2-3.1c0.3-1.4,1.7-2.3,3.1-2c1.4,0.3,2.3,1.7,2,3.1c-0.2,1-1,1.8-2,2 v226.9h51.5L489.3,816z M334.4,726.9l-7.4,7.3c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1 l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0,0.1,0,0.1C334.4,726.8,334.4,726.8,334.4,726.9L334.4,726.9z  M334.4,696.9l-7.4,7.3c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4c0,0-0.1-0.1,0-0.1c0-0.1,0-0.1,0-0.1l7.4-7.4 c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0,0.1,0,0.1C334.4,696.8,334.4,696.8,334.4,696.9L334.4,696.9z M334.4,666.9 l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0 c0,0,0,0,0,0l7.4,7.4c0,0,0,0.1,0,0.1C334.4,666.8,334.4,666.8,334.4,666.9L334.4,666.9z M334.4,636.9l-7.4,7.4 c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0 l7.4,7.4c0,0,0,0.1,0,0.2C334.4,636.8,334.4,636.9,334.4,636.9z M334.4,606.9l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0 l-7.4-7.4c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0,0.1,0,0.1 C334.4,606.8,334.4,606.9,334.4,606.9L334.4,606.9z M334.4,576.9l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4 c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0,0.1,0,0.1 C334.4,576.8,334.4,576.9,334.4,576.9L334.4,576.9z M334.4,546.9l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.3 c0,0-0.1-0.1,0-0.1c0-0.1,0-0.1,0-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4C334.4,546.8,334.4,546.8,334.4,546.9 C334.4,546.9,334.4,547,334.4,546.9L334.4,546.9z M334.4,516.9l-7.4,7.5c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4 c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4C334.4,516.8,334.4,516.8,334.4,516.9 C334.4,516.9,334.4,517,334.4,516.9L334.4,516.9z M334.4,486.9l-7.4,7.5c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4 c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4C334.4,486.8,334.4,486.8,334.4,486.9 C334.4,486.9,334.4,487,334.4,486.9L334.4,486.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753,1064l-50.8-29.3c-0.2-0.1-0.4-0.4-0.4-0.6V705.2c0-0.3,0.1-0.5,0.4-0.6l51-29.4v-49.3h-1.8v-83.3h1.8 v-124L651.9,477v407h1.8v36.7c0,0.9-0.5,1.8-1.3,2.2l-23.3,13.4l-0.9-1.6l-32.1,18.5v118.5H753V1064z M649,1061.4 c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C650.7,1060.7,649.9,1061.4,649,1061.4 C649,1061.4,649,1061.4,649,1061.4L649,1061.4z M649,1047.7c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6 C650.7,1047,649.9,1047.8,649,1047.7C649,1047.8,649,1047.8,649,1047.7L649,1047.7z M649,1034.1c-0.9,0-1.6-0.7-1.6-1.6 c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C650.7,1033.4,649.9,1034.1,649,1034.1C649,1034.1,649,1034.1,649,1034.1L649,1034.1z  M649,1020.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C650.7,1019.7,649.9,1020.5,649,1020.4 C649,1020.5,649,1020.5,649,1020.4L649,1020.4z M649,1006.8c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6 C650.7,1006.1,649.9,1006.8,649,1006.8C649,1006.8,649,1006.8,649,1006.8L649,1006.8z M649,993.1c-0.9,0-1.6-0.7-1.6-1.6 c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C650.7,992.4,649.9,993.2,649,993.1C649,993.2,649,993.2,649,993.1L649,993.1z  M649,979.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C650.7,978.8,649.9,979.5,649,979.5 C649,979.5,649,979.5,649,979.5L649,979.5z M691.9,583.2v65c1.4,0.4,2.2,1.9,1.7,3.2s-1.9,2.2-3.2,1.7c-1.4-0.4-2.2-1.9-1.7-3.2 c0.2-0.8,0.9-1.5,1.7-1.7v-65c0-3.4,1.8-6.6,4.8-8.3l13.9-8c2.5-1.4,4-4.1,4.1-7v-53.3c-1.4-0.4-2.2-1.9-1.7-3.2 c0.4-1.4,1.9-2.2,3.2-1.7s2.2,1.9,1.7,3.2c-0.2,0.8-0.9,1.5-1.7,1.7v53.3c0,3.4-1.8,6.6-4.8,8.3l-13.9,8 C693.5,577.6,691.9,580.3,691.9,583.2L691.9,583.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,871.1c1.7-3.6,4.3-6.8,7.6-9.1c-5.6,1-10.9,3.4-15.4,6.8c2,1.8,4.3,3.3,6.8,4.4 C283.3,872.5,283.6,871.8,284,871.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.4,898.3h-17.6c0,7.4,1.3,14.7,3.9,21.7c4.4-1.7,9-2.6,13.6-2.6V898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.4,874.6c-2.7-1.2-5.2-2.8-7.4-4.9c-8.1,6.7-12.9,16.6-13.1,27.1h16.4 C278.3,889.2,279.7,881.7,282.4,874.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "383.8,860.1 383.8,841.8 263.7,772.5 263.7,790.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.2,871.1c0.4,0.7,0.7,1.4,1,2.1c2.5-1.1,4.8-2.6,6.8-4.4c-4.5-3.4-9.8-5.8-15.4-6.8 C307.9,864.3,310.5,867.5,312.2,871.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.4,877.8c-4.7-0.1-9.3-0.9-13.6-2.6c-2.6,6.9-3.9,14.3-3.9,21.7h17.6V877.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.2,924c-1.7,3.6-4.3,6.8-7.6,9.1c5.6-1,10.8-3.4,15.4-6.9c-2-1.8-4.3-3.3-6.8-4.4 C312.9,922.6,312.6,923.3,312.2,924z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.9,896.8h16.4c-0.2-10.5-5-20.4-13.1-27.1c-2.2,2-4.6,3.7-7.4,4.9C316.5,881.7,317.9,889.2,317.9,896.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.8,917.3c4.7,0.1,9.3,0.9,13.6,2.6c2.6-6.9,4-14.3,3.9-21.7h-17.6V917.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.4,933.7v-14.9c-4.5,0-8.9,0.9-13.1,2.5C287.5,928.5,292.1,933.3,297.4,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.3,898.3h-16.4c0.2,10.5,5,20.4,13.1,27.1c2.2-2,4.7-3.7,7.4-4.9C279.7,913.4,278.3,905.9,278.3,898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.8,933.7c5.2-0.4,9.9-5.1,13.1-12.4c-4.2-1.6-8.6-2.5-13.1-2.5V933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.1,617.3l0.9-1.6l25.8,14.9c0.8,0.5,1.3,1.3,1.3,2.2v102.1h-1.8v216.6l31.3-18.1l-0.9-1.6l22-12.7V884h1.8 V476.6c0-0.3,0.1-0.5,0.4-0.6L753,417V315.7H596.2v251.7c1.4,0.4,2.2,1.9,1.7,3.2s-1.9,2.2-3.2,1.7c-1.4-0.4-2.2-1.9-1.7-3.2 c0.2-0.8,0.9-1.5,1.7-1.7V315.7h-104v255.8L570.1,617.3z M636.9,380.3c0-1.6,1.2-3,2.8-3.4l4.3-0.8c0.8-3.8,2.3-7.4,4.4-10.7 l-2.4-3.5c-0.9-1.4-0.7-3.2,0.4-4.3l3.2-3.2c1.2-1.2,3-1.3,4.3-0.4l3.6,2.4c3.2-2.1,6.8-3.6,10.6-4.4l0.8-4.3 c0.3-1.6,1.7-2.8,3.3-2.8h4.6c1.6,0,3,1.2,3.3,2.8l0.8,4.3c3.8,0.8,7.4,2.3,10.7,4.4l3.6-2.4c1.4-0.9,3.2-0.8,4.3,0.4l3.2,3.2 c1.2,1.2,1.3,3,0.4,4.3l-2.4,3.6c2.1,3.2,3.6,6.9,4.4,10.7l4.3,0.8c1.6,0.3,2.8,1.7,2.8,3.4v4.6c0,1.6-1.2,3-2.8,3.4l-4.3,0.8 c-0.8,3.8-2.3,7.4-4.4,10.7l2.4,3.6c0.9,1.4,0.8,3.2-0.4,4.3l-3.2,3.2c-1.2,1.2-3,1.3-4.3,0.4l-3.6-2.4c-3.2,2.1-6.9,3.6-10.7,4.4 l-0.8,4.3c-0.3,1.6-1.7,2.8-3.3,2.8h-4.6c-1.6,0-3-1.2-3.3-2.8l-0.8-4.3c-3.8-0.8-7.4-2.3-10.7-4.4l-3.6,2.4 c-1.4,0.9-3.2,0.8-4.3-0.4l-3.2-3.2c-1.2-1.2-1.3-3-0.4-4.3l2.5-3.6c-2.1-3.3-3.6-6.9-4.4-10.7l-4.3-0.8c-1.6-0.3-2.8-1.7-2.8-3.4 L636.9,380.3z M542.8,551.3c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6c0,0,0,0,0,0 C544.4,550.6,543.7,551.3,542.8,551.3L542.8,551.3z M542.8,315.9c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6 c-0.9,0-1.6-0.7-1.6-1.6C541.1,316.6,541.9,315.9,542.8,315.9L542.8,315.9L542.8,315.9z M542.8,329.6c0.9,0,1.6,0.7,1.6,1.6 c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0,0,0,0,0,0C541.1,330.3,541.9,329.6,542.8,329.6L542.8,329.6z M542.8,343.3 c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,344,541.9,343.3,542.8,343.3L542.8,343.3L542.8,343.3z  M542.8,356.9c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6C541.2,357.7,541.9,357,542.8,356.9L542.8,356.9z  M542.8,370.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,371.4,541.9,370.6,542.8,370.6 L542.8,370.6L542.8,370.6z M542.8,384.3c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6 C541.1,385,541.9,384.3,542.8,384.3L542.8,384.3z M542.8,398c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6 C541.1,398.7,541.9,398,542.8,398L542.8,398z M542.8,411.7c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6 C541.1,412.4,541.9,411.7,542.8,411.7L542.8,411.7z M542.8,425.4c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6 c-0.9,0-1.6-0.7-1.6-1.6C541.1,426.1,541.9,425.4,542.8,425.4L542.8,425.4z M542.8,439.1c0.9,0,1.6,0.7,1.6,1.6 c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,439.8,541.9,439.1,542.8,439.1L542.8,439.1L542.8,439.1z M542.8,452.7 c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,453.5,541.9,452.7,542.8,452.7L542.8,452.7z  M542.8,466.4c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,467.2,541.9,466.4,542.8,466.4 L542.8,466.4L542.8,466.4z M542.8,480.1c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0,0,0,0,0,0 C541.1,480.8,541.9,480.1,542.8,480.1L542.8,480.1z M542.8,493.8c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6 c-0.9,0-1.6-0.7-1.6-1.6C541.1,494.5,541.9,493.8,542.8,493.8L542.8,493.8L542.8,493.8z M542.8,507.5c0.9,0,1.6,0.7,1.6,1.6 c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0,0,0,0,0,0C541.1,508.2,541.9,507.5,542.8,507.5L542.8,507.5z M542.8,521.2 c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,521.9,541.9,521.2,542.8,521.2L542.8,521.2z  M542.8,534.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6C541.1,535.3,541.9,534.6,542.8,534.6 L542.8,534.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.8,861.4v14.9c4.5,0,8.9-0.9,13.1-2.5C308.7,866.5,304,861.8,298.8,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284,924c-0.4-0.7-0.7-1.4-1-2.1c-2.5,1.1-4.8,2.6-6.8,4.4c4.5,3.5,9.8,5.8,15.4,6.8 C288.3,930.8,285.7,927.6,284,924z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.4,896.8c0-7.4-1.3-14.7-3.9-21.7c-4.4,1.7-9,2.6-13.6,2.6v19L316.4,896.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.8,920.5c2.7,1.2,5.2,2.8,7.4,4.9c8.1-6.7,12.9-16.6,13.1-27.1h-16.4C317.9,905.9,316.5,913.4,313.8,920.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323,539.6l-7.3,7.2l7.3,7.2c1,1,2.7,1,3.7,0c0,0,0,0,0,0l7.3-7.2l-7.3-7.2C325.7,538.5,324,538.5,323,539.6 C323,539.6,323,539.6,323,539.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "155.2,639.2 112,664.2 112,696.1 155.2,671.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.4,899.2l-7.2,7.2l7.2,7.2c1,1,2.7,1,3.7,0l7.2-7.2l-7.2-7.2C764.1,898.2,762.5,898.2,761.4,899.2 C761.5,899.2,761.4,899.2,761.4,899.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.4,842l-7.2,7.2l7.2,7.2c1,1,2.7,1,3.7,0l7.2-7.2l-7.2-7.2C764.1,841,762.5,841,761.4,842 C761.5,842,761.4,842,761.4,842z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "824.8,721.1 868,696.1 868,664.2 824.8,689.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.4,813.4l-7.2,7.2l7.2,7.2c1,1,2.7,1,3.7,0l7.2-7.2l-7.2-7.2C764.1,812.4,762.5,812.4,761.4,813.4 C761.5,813.4,761.4,813.4,761.4,813.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M824.8,1071.8h42.7V757.6c-1.4-0.3-2.3-1.7-1.9-3.1c0.3-1.2,1.3-2,2.5-2v-54.6l-43.2,25V1071.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.4,756.2l-7.2,7.3l7.2,7.2c1,1,2.7,1,3.7,0l7.2-7.2l-7.2-7.3C764.1,755.2,762.5,755.2,761.4,756.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.7,501.1l-24.9-14.4c-0.8-0.5-1.3-1.3-1.3-2.2v-74.2h1.8v-94.6h-68.9V417c0.1,0.1,0.1,0.3,0.1,0.4v125.2 h1.8v83.3h-1.8v49.7c0,0.3-0.1,0.5-0.4,0.6l-50.9,29.4v328l49.7,28.7v-71.4c0-0.3,0.1-0.5,0.4-0.6l70-40.4V688.7 c0-0.3,0.1-0.5,0.4-0.6l44.3-25.6V510.7l-19.5-11.2L847.7,501.1z M772.8,906.6l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0 l-7.4-7.4c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4 C772.9,906.4,772.9,906.5,772.8,906.6C772.8,906.6,772.8,906.6,772.8,906.6L772.8,906.6z M772.8,878l-7.4,7.4 c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0 l7.4,7.4c0,0,0.1,0.1,0.1,0.1C772.9,877.9,772.9,878,772.8,878L772.8,878z M772.8,849.4l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0 c0,0,0,0,0,0l-7.4-7.4c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4 c0,0,0.1,0.1,0.1,0.1C772.9,849.3,772.9,849.3,772.8,849.4L772.8,849.4z M772.8,820.8l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0 l-7.4-7.4c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.1l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0.1,0.1,0.1,0.1 C772.9,820.7,772.9,820.7,772.8,820.8L772.8,820.8z M772.8,792.2l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4 c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.2l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0.1,0.1,0.1,0.2 C772.9,792.1,772.9,792.1,772.8,792.2L772.8,792.2z M772.8,763.6l-7.4,7.4c-1.2,1.2-3.1,1.2-4.2,0c0,0,0,0,0,0l-7.4-7.4 c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0.1-0.2l7.4-7.4c1.2-1.2,3.1-1.2,4.2,0c0,0,0,0,0,0l7.4,7.4c0,0,0.1,0.1,0.1,0.2 C772.9,763.5,772.8,763.6,772.8,763.6L772.8,763.6z M824.1,632.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6 c0,0,0,0,0,0C825.7,632.2,825,632.9,824.1,632.9z M824.1,619.4c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0 C825.7,618.7,825,619.4,824.1,619.4C824.1,619.4,824.1,619.4,824.1,619.4z M824.1,605.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6 s1.6,0.7,1.6,1.6c0,0,0,0,0,0C825.7,605.2,825,605.9,824.1,605.9z M824.1,592.4c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6 s1.6,0.7,1.6,1.6l0,0C825.7,591.6,825,592.4,824.1,592.4C824.1,592.4,824.1,592.4,824.1,592.4z M824.1,578.9 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6c0,0,0,0,0,0C825.7,578.2,825,578.9,824.1,578.9z M824.1,565.4 c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0C825.7,564.6,825,565.4,824.1,565.4 C824.1,565.4,824.1,565.4,824.1,565.4z M824.1,551.9c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6c0,0,0,0,0,0 C825.7,551.1,825,551.9,824.1,551.9z M824.1,538.4c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6l0,0 C825.7,537.6,825,538.4,824.1,538.4C824.1,538.4,824.1,538.4,824.1,538.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.4,784.8l-7.2,7.2l7.2,7.2c1,1,2.7,1,3.7,0l7.2-7.2l-7.2-7.3C764.1,783.7,762.5,783.8,761.4,784.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.9,918.8h-1.8v-78.1h1.8V315.7h-54.2v355.9c0,0.2-0.1,0.3-0.2,0.5v399.7h54.4L210.9,918.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M826.7,410.3V483l23.6,13.6l-0.9,1.6L868,509v-55c-1.4,0-2.6-1.2-2.6-2.6c0-1.2,0.8-2.3,2-2.5V315.7h-42.7 v94.6H826.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.4,672.8L112,697.8v54.6c1.4,0,2.6,1.1,2.6,2.5c0,1.2-0.9,2.3-2.1,2.6v314.2h42.9L155.4,672.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M761.4,870.6l-7.2,7.2l7.2,7.2c1,1,2.7,1,3.7,0l7.2-7.2l-7.2-7.2C764.1,869.6,762.5,869.6,761.4,870.6 C761.5,870.6,761.4,870.6,761.4,870.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "823.3,951.5 754.4,991.3 754.4,1071.8 754.4,1071.8 823.3,1071.8 823.3,1071.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "329.1,977.8 383.8,946.2 383.8,944.5 328.3,976.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "310.4,1008.3 308.9,1008.3 308.9,1071.8 308.9,1071.8 310.4,1071.8 310.4,1071.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,479.3c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1L327,479.3z M326.7,494.1c-1,1-2.7,1-3.7,0l-7.3-7.2 l7.2-7.3c1-1,2.7-1,3.7,0l7.3,7.3L326.7,494.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,497.8C324.8,497.8,324.8,497.8,324.9,497.8c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.7-0.5-1 l-0.6-0.6l0.6-0.6c0.1-0.4,0.3-0.7,0.5-1l0.2-0.3l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.6c0,0.1,0,0.2,0.1,0.2l0.6,0.6 l-0.6,0.6c0,0.1,0,0.1-0.1,0.2l-0.2,0.6l-7.8,7.8C327.7,497.2,326.3,497.8,324.9,497.8z M319.3,486.8l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,486.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,509.3c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1,0,0.1c0,0.1,0,0.1,0,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1L327,509.3z M326.7,524.1c-1,1-2.7,1-3.7,0l-7.3-7.2 l7.3-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.3,7.2L326.7,524.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,527.8C324.8,527.8,324.8,527.8,324.9,527.8c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.7-0.5-1 l-0.6-0.6l0.6-0.6c0.1-0.4,0.3-0.8,0.6-1.2l0.1-0.1l7.4-7.4c1.1-1.1,2.5-1.6,3.9-1.6c0,0,0,0,0,0c1.5,0,2.8,0.6,3.9,1.6l7.8,7.8 l0.2,0.5c0,0.1,0.1,0.2,0.1,0.3l0.7,0.7l-0.7,0.7c0,0.1,0,0.1,0,0.2l-0.2,0.6l-7.9,7.9C327.7,527.2,326.3,527.8,324.9,527.8z  M319.3,516.8l5.5,5.5c0,0,0.1,0,0.2,0l5.5-5.5l-5.5-5.5c-0.1-0.1-0.1-0.1-0.2,0L319.3,516.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,539.3c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1L327,539.3z M326.7,554.1c-1,1-2.7,1-3.7,0 c0,0,0,0,0,0l-7.3-7.2l7.3-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.3,7.2L326.7,554.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,557.7C324.8,557.7,324.8,557.7,324.9,557.7c-1.5,0-2.9-0.6-3.9-1.6l-7.5-7.5c-0.3-0.3-0.5-0.7-0.5-1.1 l-0.6-0.6l0.6-0.6c0.1-0.4,0.3-0.7,0.5-1l0.2-0.2l7.4-7.4c1.1-1.1,2.5-1.7,4-1.6c1.5,0,2.8,0.6,3.9,1.6l7.8,7.8l0.2,0.6 c0,0.1,0,0.1,0,0.2l0.7,0.7l-0.7,0.7c0,0.1,0,0.2-0.1,0.3l-0.2,0.6l-7.9,7.9C327.7,557.2,326.3,557.7,324.9,557.7z M319.3,546.8 l5.5,5.5c0,0,0.1,0,0.2,0l5.5-5.5l-5.5-5.5c-0.1-0.1-0.1-0.1-0.2,0L319.3,546.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,569.3c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1L327,569.3z M326.7,584c-1,1-2.7,1-3.7,0c0,0,0,0,0,0 l-7.3-7.2l7.3-7.2c1-1,2.7-1,3.7,0l7.3,7.2L326.7,584z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,587.7C324.8,587.7,324.8,587.7,324.9,587.7c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.7-0.5-1 l-0.7-0.7l0.7-0.7c0.1-0.3,0.3-0.7,0.5-0.9l0.2-0.2l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.6c0,0.1,0,0.1,0.1,0.2l0.6,0.6 l-0.6,0.6c0,0.1,0,0.2-0.1,0.3l-0.2,0.6l-7.9,7.9C327.7,587.2,326.3,587.7,324.9,587.7z M319.3,576.8l5.5,5.5c0,0,0.1,0,0.2,0l0,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,576.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,599.3c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1L327,599.3z M326.7,614c-1,1-2.7,1-3.7,0l-7.3-7.3 l7.3-7.2c1-1,2.7-1,3.7,0l7.3,7.2L326.7,614z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,617.7C324.8,617.7,324.8,617.7,324.9,617.7c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.6-0.5-1 l-0.7-0.7l0.7-0.7c0.1-0.4,0.3-0.7,0.5-0.9l0.2-0.2l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.6c0,0.1,0,0.1,0.1,0.2l0.6,0.6 l-0.6,0.6c0,0.1,0,0.2-0.1,0.3l-0.2,0.6l-7.9,7.9C327.7,617.1,326.3,617.7,324.9,617.7z M319.3,606.8l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,606.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,629.2c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2L327,629.2z M326.7,644c-1,1-2.7,1-3.7,0l-7.3-7.2 l7.3-7.3c1-1,2.7-1,3.7,0l7.3,7.3L326.7,644z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,647.7C324.8,647.7,324.8,647.7,324.9,647.7c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.6-0.5-1 l-0.7-0.7l0.7-0.7c0.1-0.4,0.2-0.7,0.5-1l0.2-0.3l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.6c0,0.1,0.1,0.2,0.1,0.3l0.6,0.6 l-0.6,0.6c0,0.1,0,0.2-0.1,0.3l-0.2,0.6l-7.9,7.9C327.7,647.1,326.3,647.7,324.9,647.7z M319.3,636.8l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,636.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,659.2c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1,0,0.1c0,0.1,0,0.1,0,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1L327,659.2z M326.7,674c-1,1-2.7,1-3.7,0l-7.3-7.2 l7.3-7.3c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.3,7.2L326.7,674z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,677.7C324.8,677.7,324.8,677.7,324.9,677.7c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.6-0.5-1 l-0.7-0.7l0.7-0.7c0.1-0.4,0.3-0.8,0.6-1.1l0.1-0.1l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.5c0,0.1,0.1,0.2,0.1,0.4l0.6,0.6 l-0.7,0.6c0,0.1,0,0.1-0.1,0.2l-0.2,0.6l-7.9,7.9C327.7,677.1,326.3,677.7,324.9,677.7z M319.3,666.8l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,666.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,689.2c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1L327,689.2z M326.7,704c-1,1-2.7,1-3.7,0c0,0,0,0,0,0 l-7.3-7.2l7.3-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.3,7.2L326.7,704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,707.6C324.8,707.6,324.8,707.6,324.9,707.6c-1.5,0-2.9-0.6-3.9-1.6l-7.5-7.5c-0.2-0.3-0.4-0.6-0.5-1 l-0.7-0.7l0.7-0.7c0.1-0.4,0.3-0.7,0.5-1l0.2-0.2l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.6c0,0.1,0.1,0.2,0.1,0.3l0.6,0.6 l-0.6,0.6c0,0.1,0,0.2-0.1,0.3l-0.2,0.6l-7.9,7.9C327.7,707.1,326.3,707.6,324.9,707.6z M319.3,696.8l5.5,5.5c0,0,0.1,0,0.2,0l0,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,696.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327,719.2c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1L327,719.2z M326.7,734c-1,1-2.7,1-3.7,0l-7.3-7.3 l7.3-7.2c1-1,2.7-1,3.7,0l7.3,7.2L326.7,734z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.9,737.6C324.8,737.6,324.8,737.6,324.9,737.6c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.2-0.3-0.4-0.6-0.4-0.9 l-0.7-0.7l0.7-0.7c0.1-0.4,0.3-0.7,0.5-1.1l0.2-0.2l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.8,7.8l0.2,0.6c0,0.1,0.1,0.2,0.1,0.3l0.6,0.6 l-0.6,0.6c0,0.1,0,0.1-0.1,0.2l-0.2,0.6l-7.9,7.9C327.7,737.1,326.3,737.6,324.9,737.6z M319.3,726.8l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L319.3,726.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M491.1,714.5l-6.5,6.5c-5.5,5.5-14.3,5.5-19.8,0c0,0,0,0,0,0l-27.3-27.3l2.2-2.2c4.2-4.2,11.1-4.2,15.3,0 l25.1,25.2l6.4-6.4l-25.1-25.2c-7.8-7.7-20.3-7.7-28.1,0l-8.6,8.6l33.7,33.7c9,9,23.6,9,32.6,0l6.5-6.5c4.2-4.2,11.1-4.2,15.3,0 l1.3,1.3l-16.2,16.3c-3.8,3.8-9.8,4.3-14.1,1.2c-4,0.7-8.1,1-12.2,0.9l4.3,4.3c7.8,7.8,20.5,7.8,28.4,0l22.7-22.7l-7.7-7.7 C511.4,706.8,498.9,706.8,491.1,714.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M489,660l-6.5,6.5c-4.2,4.2-11.1,4.2-15.3,0c0,0,0,0,0,0l-1.2-1.2l16.2-16.3c3.8-3.8,9.8-4.3,14.1-1.2 c4-0.7,8.1-1,12.2-0.9l-4.3-4.3c-7.8-7.8-20.5-7.8-28.4,0l-22.7,22.7l7.7,7.7c7.8,7.7,20.3,7.7,28.1,0l6.5-6.5 c5.5-5.5,14.3-5.5,19.8,0c0,0,0,0,0,0l27.3,27.3l-2.2,2.2c-4.2,4.2-11.1,4.2-15.3,0l-25.1-25.1l-6.4,6.4l25.1,25.2 c7.8,7.7,20.3,7.7,28.1,0l8.6-8.6L521.6,660C512.6,651,498,651,489,660z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M385.3,841.4c0-0.3-0.1-0.5-0.4-0.6l-121.2-70v1.7l120.1,69.3V860l1.1,0.6c0.3,0.2,0.5,0.6,0.3,1 c-0.1,0.2-0.4,0.4-0.6,0.4c-0.1,0-0.3,0-0.4-0.1l-0.4-0.2v82.7l0.4-0.2c0.4-0.2,0.8-0.1,1,0.3c0.2,0.4,0.1,0.8-0.3,1l-1.1,0.6 v125.5h1.5L385.3,841.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.9,945.6c0.3-0.2,0.5-0.6,0.3-1c-0.2-0.3-0.6-0.5-1-0.3l-0.4,0.2v1.7L384.9,945.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,452.4c0.4,0,0.7,0.3,0.7,0.7v1.3l49.8,28.8v27.1h1.5v-27.5c0-0.3-0.1-0.5-0.4-0.6l-51-29.4v-137h-1.5 v137.4C210.9,452.7,211.2,452.4,211.7,452.4C211.6,452.4,211.7,452.4,211.7,452.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.3,791.2c0,0.3,0.1,0.5,0.4,0.6l121.2,70v-1.7l-120.1-69.4v-18.2l-1.1-0.6c-0.3-0.2-0.5-0.6-0.3-1 c0,0,0,0,0,0c0.2-0.4,0.6-0.5,1-0.3c0,0,0,0,0,0l0.4,0.2V588.4h-1.5L262.3,791.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.4,770.9c-0.2,0.3-0.1,0.8,0.2,1c0,0,0,0,0,0l1.1,0.6v-1.7l-0.4-0.2C263,770.4,262.6,770.5,262.4,770.9 C262.4,770.9,262.4,770.9,262.4,770.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.2,862c0.1,0.1,0.2,0.1,0.4,0.1c0.3,0,0.5-0.1,0.6-0.4c0.2-0.4,0.1-0.8-0.3-1l-1.1-0.6v1.7L384.2,862z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "155.2,637.5 112,662.5 112,664.2 155.2,639.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M155.4,671.6c0-0.3,0.2-0.6,0.5-0.6c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1v0.5c0.1-0.1,0.2-0.3,0.2-0.5V315.7 h-1.5v218l1.1,0.6c0.4,0.2,0.5,0.6,0.3,1c0,0,0,0,0,0c-0.1,0.2-0.4,0.4-0.6,0.4c-0.1,0-0.3,0-0.4-0.1l-0.4-0.2v102.1l0.4-0.2 c0.4-0.2,0.8-0.1,1,0.3c0.2,0.3,0.1,0.8-0.3,1c0,0,0,0,0,0l-1.1,0.6v31.9l-43.2,25v1.7l43.4-25.1L155.4,671.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.3,638.6c0.4-0.2,0.5-0.6,0.3-1c0,0,0,0,0,0c-0.2-0.3-0.6-0.5-1-0.3l-0.4,0.2v1.7L156.3,638.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M823.3,688.7v261.1l0.4-0.2c0.4-0.2,0.8-0.1,1,0.3s0.1,0.8-0.3,1l-1.1,0.6v120.2h1.5v-349l-0.4,0.2 c-0.1,0.1-0.2,0.1-0.4,0.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.3,0.1-0.5,0.4-0.7l1.1-0.6v-32l43.2-25v-1.7l-44.3,25.8 C823.5,688.2,823.3,688.5,823.3,688.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "824.8,722.8 868,697.8 868,696.1 824.8,721.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M823.7,721.8c-0.4,0.2-0.5,0.6-0.3,1c0.1,0.2,0.4,0.4,0.7,0.4c0.1,0,0.3,0,0.4-0.1l0.4-0.2v-1.7L823.7,721.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M650.8,475.9c-0.2,0.1-0.4,0.4-0.4,0.6v361.3c0-0.4,0.2-0.8,0.6-0.8s0.8,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2V477 l101.2-58.4v-1.2c0-0.4,0.3-0.7,0.7-0.7c0.2,0,0.5,0.1,0.6,0.3V315.7H753V417L650.8,475.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.9,
    y: 315.7,
    className: "st6",
    width: 1.5,
    height: 63.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "329.1,409.6 328.3,410.9 383.8,442.9 383.8,441.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "329.1,409.6 330,408 312.3,397.8 312.3,379.1 310.4,379.1 310.4,398.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M308.9,399.3v-20.2h-1.9v20.2c0,0.9,0.5,1.8,1.3,2.2l19,11l0.9-1.6l-19-11 C309.1,399.8,308.9,399.6,308.9,399.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.4,398.9v-19.8h-1.5v20.2c0,0.3,0.1,0.5,0.4,0.6l19,11l0.7-1.3L310.4,398.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "310.4,1008.3 312.3,1008.3 312.3,989.7 330,979.4 329.1,977.8 310.4,988.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M309.3,987.5l19-11l-0.9-1.6l-19,11c-0.8,0.5-1.3,1.3-1.3,2.2v20.2h1.9v-20.2 C308.9,987.9,309.1,987.7,309.3,987.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M309.3,987.5c-0.2,0.1-0.4,0.4-0.4,0.6v20.2h1.5v-19.8l18.7-10.8l-0.7-1.3L309.3,987.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M596.2,953.2l-0.4,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.3,0.1-0.5,0.4-0.7l1.1-0.6V734.9 h-1.5v336.8h1.5V953.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M489.6,572.6l79.7,46l0.7-1.3l-79.3-45.8V315.7h-1.5v256.2C489.3,572.2,489.4,572.4,489.6,572.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M595.5,567.3c0.3,0,0.5,0,0.7,0.1V315.7h-1.5v251.7C595,567.3,595.2,567.3,595.5,567.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 777.8,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 791.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 804.6,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 818.1,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 831.5,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,843.3c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0C544.4,844,543.7,843.3,542.8,843.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,856.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,857.5,543.7,856.8,542.8,856.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,870.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,870.9,543.7,870.2,542.8,870.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,883.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0 C544.4,884.4,543.7,883.6,542.8,883.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,897.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0 C544.4,897.8,543.7,897.1,542.8,897.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,910.5c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0 C544.4,911.2,543.7,910.5,542.8,910.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 925.6,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 939,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 952.4,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 965.9,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 979.3,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,991.1c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,991.9,543.7,991.1,542.8,991.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,1004.6c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,1005.3,543.7,1004.6,542.8,1004.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,1018c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0C544.4,1018.7,543.7,1018,542.8,1018z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,1031.4c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0 C544.4,1032.2,543.7,1031.4,542.8,1031.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,1044.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,1045.6,543.7,1044.9,542.8,1044.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,1058.3c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,1059,543.7,1058.3,542.8,1058.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.8,844.8c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.5-0.1v226.9h1.1V844.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,524.4c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,523.7,541.9,524.4,542.8,524.4C542.8,524.4,542.8,524.4,542.8,524.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 509.1,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,497c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,496.3,541.9,497.1,542.8,497z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 481.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,469.7c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,469,541.9,469.7,542.8,469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,456c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,455.3,541.9,456,542.8,456C542.8,456,542.8,456,542.8,456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,442.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,441.6,541.9,442.3,542.8,442.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 542.8,
    cy: 427,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,414.9c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6c0,0,0,0,0,0 C541.1,414.2,541.9,414.9,542.8,414.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,401.3c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,400.5,541.9,401.3,542.8,401.3C542.8,401.3,542.8,401.3,542.8,401.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,387.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6c0,0,0,0,0,0 C541.1,386.8,541.9,387.6,542.8,387.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,373.9c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,373.2,541.9,373.9,542.8,373.9C542.8,373.9,542.8,373.9,542.8,373.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,360.2c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6c0,0,0,0,0,0 C541.1,359.5,541.9,360.2,542.8,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,346.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,345.8,541.9,346.5,542.8,346.5C542.8,346.5,542.8,346.5,542.8,346.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,332.8c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6C541.1,332.1,541.9,332.8,542.8,332.8 L542.8,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,319.1c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,318.4,541.9,319.1,542.8,319.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.3,618.1c0.2,0,0.4,0,0.6,0.1V315.7h-1.1v302.5C436.9,618.2,437.1,618.1,437.3,618.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M595.5,569.5c-0.4,0-0.7-0.3-0.7-0.7v-1.4c-1.4,0.4-2.2,1.9-1.7,3.2s1.9,2.2,3.2,1.7c1.4-0.4,2.2-1.9,1.7-3.2 c-0.2-0.8-0.9-1.5-1.7-1.7v1.4C596.2,569.2,595.9,569.5,595.5,569.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M594.8,567.4v1.4c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.4c-0.2-0.1-0.5-0.1-0.7-0.1 C595.2,567.3,595,567.3,594.8,567.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M598.1,632.8c0-0.9-0.5-1.8-1.3-2.2L571,615.7l-0.9,1.6l25.8,14.9c0.2,0.1,0.4,0.4,0.4,0.6v102.1h1.8 L598.1,632.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "569.3,618.6 568.4,620.2 592.9,634.3 592.9,734.9 594.8,734.9 594.8,633.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M595.9,632.2l-25.8-14.9l-0.7,1.3l25.4,14.7v101.7h1.5V632.8C596.2,632.6,596.1,632.3,595.9,632.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 510.3,
    className: "st6",
    width: 1.9,
    height: 78.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.7,
    y: 510.3,
    className: "st6",
    width: 1.8,
    height: 78.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 510.3,
    className: "st6",
    width: 1.5,
    height: 78.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M490.8,815.5c0-0.3-0.1-0.5-0.4-0.6l-79.7-46l-0.7,1.3l79.3,45.8v255.8h1.5V815.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.9,441.9c0.3,0.2,0.5,0.6,0.3,1c-0.1,0.2-0.4,0.4-0.6,0.4c-0.1,0-0.3,0-0.4-0.1l-0.4-0.2v209.6h1.5V315.7 h-1.5v125.6L384.9,441.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.5,443.2c0.3,0,0.5-0.1,0.6-0.4c0.2-0.4,0.1-0.8-0.3-1l-1.1-0.6v1.7l0.4,0.2 C384.3,443.2,384.4,443.2,384.5,443.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "410.7,768.9 411.6,767.3 387.1,753.1 387.1,652.5 385.3,652.5 385.3,754.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M383.8,754.6V652.5H382v102.1c0,0.9,0.5,1.8,1.3,2.2l25.8,14.9l0.9-1.6l-25.8-14.9 C384,755.1,383.8,754.9,383.8,754.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M383.8,754.6c0,0.3,0.1,0.5,0.4,0.6l25.8,14.9l0.7-1.3l-25.4-14.7V652.5h-1.5L383.8,754.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,453.1v387.6h1.5V454.4l-1.1-0.6C211.1,453.6,210.9,453.4,210.9,453.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "212.4,918.8 210.9,918.8 210.9,1071.8 210.9,1071.8 212.4,1071.8 212.4,1071.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.7,452.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.3,0.1,0.5,0.4,0.6l1.1,0.6v-1.3C212.4,452.7,212.1,452.4,211.7,452.4 C211.7,452.4,211.7,452.4,211.7,452.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.1,
    y: 840.8,
    className: "st6",
    width: 1.9,
    height: 78.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.4,
    y: 840.8,
    className: "st6",
    width: 1.9,
    height: 78.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 840.8,
    className: "st6",
    width: 1.5,
    height: 78.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M260.7,967.9c0.4,0,0.7,0.3,0.7,0.7v1.3c1.4-0.4,2.1-1.8,1.7-3.2c-0.4-1.4-1.8-2.1-3.2-1.7s-2.1,1.8-1.7,3.2 c0.2,0.8,0.9,1.5,1.7,1.7v-1.3C259.9,968.3,260.3,967.9,260.7,967.9C260.7,967.9,260.7,967.9,260.7,967.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.4,970c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.7-0.1v101.8h1.5L261.4,970z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.4,970v-1.3c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v1.3c0.2,0.1,0.5,0.1,0.7,0.1 C260.9,970.1,261.2,970.1,261.4,970z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M260.7,419.5c-0.4,0-0.7-0.3-0.7-0.7v-1.3c-1.4,0.4-2.2,1.9-1.8,3.2c0.4,1.4,1.9,2.2,3.2,1.8s2.2-1.9,1.8-3.2 c-0.3-0.8-0.9-1.5-1.8-1.8v1.3C261.4,419.2,261.1,419.5,260.7,419.5C260.7,419.5,260.7,419.5,260.7,419.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M260.7,417.4c0.3,0,0.5,0,0.8,0.1V315.7h-1.5v101.8C260.2,417.4,260.4,417.4,260.7,417.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.9,417.5v1.3c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1.3c-0.2-0.1-0.5-0.1-0.8-0.1 C260.4,417.4,260.2,417.4,259.9,417.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.2,896.8h0.7c0.2-10.5,5-20.4,13.1-27.1c-0.2-0.2-0.3-0.3-0.5-0.5c-0.1-0.1-0.2-0.4-0.2-0.6 c0-0.2,0.1-0.3,0.2-0.5c-8.9,7.1-14.1,17.9-14.1,29.3C260.4,897.1,260.8,896.8,261.2,896.8C261.2,896.8,261.2,896.8,261.2,896.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.3,860.3h0.1H292.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.1,935.1l-1.3,0.1L301.1,935.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,935.2h-1.4H298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M304.6,933.1c5.6-1,10.9-3.4,15.4-6.8l0,0C315.5,929.8,310.2,932.1,304.6,933.1L304.6,933.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.3,935.2l-1.3-0.1L296.3,935.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,859.9c0.5,0,1,0,1.4,0C299,859.9,298.6,859.9,298.1,859.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.3,926.4c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.3,0.5-0.5c-8.1-6.7-12.9-16.6-13.1-27.1h-0.7 c-0.4,0-0.7-0.3-0.7-0.7c0,11.4,5.2,22.2,14.1,29.3C274.4,926.7,274.3,926.6,274.3,926.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.5,935l-0.7-0.1L294.5,935z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.3,934.8h0.2H292.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.9,868.7c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.3,0.3-0.5,0.5c8.1,6.7,12.9,16.6,13.1,27.1h0.7 c0.4,0,0.7,0.3,0.7,0.7c0-11.4-5.2-22.2-14.1-29.3C321.8,868.3,321.9,868.5,321.9,868.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.5,935.2c-0.5,0-0.9,0-1.4,0C298.6,935.2,299,935.2,299.5,935.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291.6,862c-5.6,1-10.9,3.4-15.4,6.8l0,0C280.7,865.4,286,863,291.6,862L291.6,862z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.1,860l1.3-0.1L295.1,860z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.9,859.9l1.3,0.1L299.9,859.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320,868.8L320,868.8c-4.5-3.5-9.8-5.8-15.4-6.8l0,0C310.2,863,315.5,865.3,320,868.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.7,859.9h1.4H296.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.9,934.8h-0.2H303.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.2,926.3L276.2,926.3c4.5,3.5,9.8,5.8,15.4,6.8l0,0C286,932.1,280.7,929.7,276.2,926.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.8,860.1l0.7-0.1L293.8,860.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.7,860l0.7,0.1L301.7,860z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M335,898.3h-0.8c-0.2,10.5-5,20.4-13.1,27.1c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.2,0.4,0.2,0.6 c0,0.2-0.1,0.3-0.2,0.5c8.9-7.1,14.1-17.9,14.1-29.3C335.7,897.9,335.4,898.3,335,898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.4,935l-0.7,0.1L302.4,935z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.7,860.3h0.1H303.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.7,875.1c-0.5-0.2-0.9-0.4-1.3-0.6c-2.7,7.1-4.1,14.6-4.1,22.2h1.5C279.8,889.4,281.1,882.1,283.7,875.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,861.4c5.2,0.4,9.9,5.1,13.1,12.4c0.5-0.2,0.9-0.4,1.3-0.6c-0.3-0.7-0.6-1.4-1-2.1 c-1.7-3.6-4.3-6.8-7.6-9.1c-0.9-0.2-1.7-0.3-2.6-0.4l-0.6-0.1h-0.5l-1.2-0.1h-0.4L298.8,861.4L298.8,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M279.8,898.3h-1.5c0,7.6,1.4,15.1,4.1,22.2c0.4-0.2,0.9-0.4,1.3-0.6C281.1,913,279.8,905.7,279.8,898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,933.7c-5.2-0.4-9.9-5.1-13.1-12.4c-0.5,0.2-0.9,0.4-1.3,0.6c0.3,0.7,0.7,1.4,1,2.1 c1.7,3.6,4.3,6.8,7.6,9.1c0.9,0.2,1.7,0.3,2.6,0.4c0.2,0,0.4,0,0.6,0.1l0.5,0c0.4,0,0.8,0.1,1.2,0.1h0.3L297.4,933.7L297.4,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M284,871.1c-0.4,0.7-0.7,1.4-1,2.1c0.4,0.2,0.9,0.4,1.3,0.6c3.2-7.3,7.9-12,13.1-12.4l0,0h-0.6h-0.3l-1.2,0.1 h-0.5l-0.6,0.1c-0.9,0.1-1.7,0.2-2.6,0.4C288.3,864.3,285.7,867.4,284,871.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.4,896.8h1.5c0-7.6-1.4-15.1-4.1-22.2c-0.4,0.2-0.9,0.4-1.3,0.6C315.1,882.1,316.4,889.4,316.4,896.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.2,924c0.4-0.7,0.7-1.4,1-2.1c-0.4-0.2-0.9-0.4-1.3-0.6c-3.2,7.3-7.9,12-13.1,12.4l0,0h0.6h0.4 c0.4,0,0.8,0,1.2-0.1l0.5,0l0.6-0.1c0.9-0.1,1.7-0.2,2.6-0.4C307.9,930.8,310.5,927.6,312.2,924z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.5,919.9c0.5,0.2,0.9,0.4,1.3,0.6c2.7-7.1,4.1-14.6,4.1-22.2h-1.5C316.4,905.7,315.1,913,312.5,919.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.1,933.5c0.9-0.1,1.7-0.2,2.6-0.4l0,0C303.8,933.3,303,933.4,302.1,933.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.3,933.6l-0.5,0L295.3,933.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.7,861.5h0.5H294.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M304.6,862c-0.8-0.2-1.7-0.3-2.6-0.4C303,861.7,303.8,861.8,304.6,862L304.6,862z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.1,861.6c-0.9,0.1-1.7,0.2-2.6,0.4l0,0C292.4,861.8,293.3,861.7,294.1,861.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.8,933.7h-0.3H296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291.5,933.1L291.5,933.1c0.9,0.2,1.7,0.3,2.6,0.4C293.3,933.4,292.4,933.3,291.5,933.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.4,861.4h0.4H299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.5,861.4h0.3H296.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.8,933.7h-0.4H299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.5,933.5l-0.5,0L301.5,933.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.9,861.5h0.5H300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.9,897.5c0,0.2,0,0.5,0,0.7h16.4c0-0.2,0-0.5,0-0.7s0-0.5,0-0.7h-16.4C317.9,897,317.9,897.3,317.9,897.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,898.3h17.6c0-0.2,0-0.5,0-0.7s0-0.5,0-0.7h-17.6V898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M278.3,897.5c0-0.3,0-0.5,0-0.7h-16.4c0,0.2,0,0.5,0,0.7s0,0.5,0,0.7h16.4C278.3,898,278.3,897.8,278.3,897.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,896.8h-17.6v1.5h17.6V896.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M335,896.8h-0.8c0,0.2,0,0.5,0,0.7s0,0.5,0,0.7h0.8c0.4,0,0.8-0.2,0.8-0.6c0-0.4-0.2-0.8-0.6-0.8 C335.1,896.8,335.1,896.8,335,896.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.2,898.3h0.7c0-0.2,0-0.5,0-0.7s0-0.5,0-0.7h-0.7c-0.4,0-0.8,0.2-0.8,0.6c0,0.4,0.2,0.8,0.6,0.8 C261.1,898.3,261.1,898.3,261.2,898.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M279.8,897.5v-0.7h-1.5c0,0.2,0,0.5,0,0.7s0,0.5,0,0.7h1.5V897.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.4,897.5c0,0.2,0,0.5,0,0.7h1.5c0-0.2,0-0.5,0-0.7s0-0.5,0-0.7h-1.5C316.4,897,316.4,897.3,316.4,897.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,896.8v-19h-1.5v19H298.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,876.3h0.7h0.7v-14.9c-0.2,0-0.5,0-0.7,0s-0.5,0-0.7,0V876.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,918.8h-0.7h-0.7v14.9c0.3,0,0.5,0,0.7,0s0.5,0,0.7,0V918.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,898.3v19h1.5v-19H297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,933.7c-0.2,0-0.5,0-0.7,0H298.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,933.7h0.7C297.8,933.7,297.6,933.7,297.4,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,861.4c0.3,0,0.5,0,0.7,0H297.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,861.4h-0.7C298.4,861.4,298.6,861.4,298.8,861.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.4,
    y: 896.8,
    className: "st6",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.5,875.1c-0.2-0.5-0.4-0.9-0.6-1.3c-4.2,1.6-8.6,2.5-13.1,2.5v1.5C303.5,877.7,308.1,876.8,312.5,875.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.8,874.6c2.7-1.2,5.2-2.8,7.4-4.9c-0.4-0.3-0.8-0.6-1.1-0.9c-2,1.8-4.3,3.3-6.8,4.4 C313.5,873.7,313.6,874.1,313.8,874.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.5,859.9L299.5,859.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,877.8v-1.5c-4.5,0-8.9-0.9-13.1-2.5l-0.6,1.3C288.1,876.8,292.7,877.7,297.4,877.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.1,860h0.6H301.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.6,868.1c-5.1-4.1-11.2-6.8-17.8-7.8C310.4,861.3,316.6,864.1,321.6,868.1L321.6,868.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.6,868.1L274.6,868.1c5.1-4.1,11.2-6.8,17.8-7.8C285.8,861.3,279.7,864,274.6,868.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.5,860.3c0.5-0.1,0.9-0.1,1.4-0.2C293.4,860.2,292.9,860.2,292.5,860.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.4,860.1l1.4,0.2L302.4,860.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283,873.2c-2.5-1.1-4.8-2.6-6.8-4.4c-0.4,0.3-0.8,0.6-1.2,0.9c2.2,2,4.7,3.7,7.4,4.9 C282.6,874.1,282.8,873.7,283,873.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.3,859.9L296.3,859.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.5,860h0.6H294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.3,868.7c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.3,0.3,0.5,0.5c0.4-0.3,0.8-0.6,1.2-0.9l0,0 c4.5-3.5,9.8-5.8,15.4-6.8c1.9-1.3,4.2-2,6.5-2.1h-1.4h-0.4l-1.3,0.1h-0.6l-0.7,0.1c-0.5,0.1-0.9,0.1-1.4,0.2h-0.1 c-6.5,1-12.7,3.7-17.8,7.9C274.4,868.3,274.3,868.5,274.3,868.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320,868.8L320,868.8c0.4,0.3,0.8,0.6,1.1,0.9c0.2-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.2-0.4,0.2-0.6 c0-0.2-0.1-0.3-0.2-0.5c-5.1-4.2-11.3-6.9-17.8-7.9h-0.1l-1.4-0.2l-0.7-0.1h-0.6l-1.3-0.1h-0.3c-0.5,0-0.9,0-1.4,0 c2.3,0,4.6,0.7,6.5,2.1C310.2,863,315.5,865.3,320,868.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.4,861.4L299.4,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,861.4L297.4,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.5,861.5l0.6,0.1L301.5,861.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.8,874.6c-0.2-0.5-0.4-0.9-0.6-1.3c-0.4,0.2-0.9,0.4-1.3,0.6c0.2,0.4,0.4,0.9,0.6,1.3 C312.9,875,313.4,874.8,313.8,874.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M284.3,873.8c-0.5-0.2-0.9-0.4-1.3-0.6c-0.2,0.4-0.4,0.9-0.6,1.3c0.4,0.2,0.9,0.4,1.3,0.6L284.3,873.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.1,861.6l0.6-0.1L294.1,861.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.8,861.4l1.2,0.1L299.8,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.3,861.5l1.2-0.1L295.3,861.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,860.6v0.8h0.6h0.4l1.2,0.1h0.5l0.6,0.1c0.9,0.1,1.7,0.2,2.6,0.4c-1.9-1.3-4.2-2-6.5-2.1 C298.5,859.8,298.8,860.1,298.8,860.6C298.8,860.6,298.8,860.6,298.8,860.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.1,861.6l0.6-0.1h0.5l1.2-0.1h0.3h0.6v-0.8c0-0.4,0.3-0.7,0.7-0.7c-2.3,0-4.6,0.7-6.5,2.1 C292.4,861.8,293.3,861.7,294.1,861.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,877.8h0.7v-1.5h-0.7h-0.7v1.5L298.1,877.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,861.4L298.8,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,861.4L298.1,861.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,860.6v0.8h1.5v-0.8c0-0.4-0.3-0.7-0.7-0.7C297.7,859.9,297.4,860.2,297.4,860.6L297.4,860.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.6,926.9L321.6,926.9c-5.1,4.1-11.2,6.8-17.8,7.8C310.4,933.8,316.5,931.1,321.6,926.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.6,926.9c5.1,4.1,11.2,6.8,17.8,7.8C285.8,933.7,279.7,931,274.6,926.9L274.6,926.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.3,921.8c2.5,1.1,4.8,2.6,6.8,4.4c0.4-0.3,0.8-0.6,1.1-0.9c-2.2-2-4.7-3.7-7.4-4.9 C313.6,921,313.5,921.4,313.3,921.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,917.3v1.5c4.5,0,8.9,0.9,13.1,2.5c0.2-0.4,0.4-0.9,0.6-1.3C308.1,918.2,303.5,917.3,298.8,917.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.7,935.2L296.7,935.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.7,935l-0.6,0L301.7,935z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.9,935.2L299.9,935.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M282.4,920.5c-2.7,1.2-5.2,2.8-7.4,4.9c0.4,0.3,0.8,0.6,1.2,0.9c2-1.8,4.3-3.3,6.8-4.4 C282.8,921.4,282.6,921,282.4,920.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.7,934.8c-0.4,0.1-0.9,0.1-1.3,0.2C302.8,934.9,303.3,934.8,303.7,934.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.7,919.9c0.2,0.5,0.4,0.9,0.6,1.3c4.2-1.6,8.6-2.5,13.1-2.5v-1.5C292.7,917.3,288.1,918.2,283.7,919.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.1,935.1l-0.6,0L295.1,935.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.8,935l-1.3-0.2C292.9,934.8,293.4,934.9,293.8,935z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.8,935l0.7,0.1l0.6,0l1.3,0.1h0.4h1.4c-2.3,0-4.6-0.7-6.5-2.1c-5.6-1-10.9-3.4-15.4-6.8l0,0 c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.2,0.4-0.2,0.6c0,0.2,0.1,0.3,0.2,0.5c5.1,4.2,11.3,6.9,17.8,7.9 h0.2L293.8,935z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.9,926.4c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.3-0.3-0.5-0.5c-0.4,0.3-0.8,0.6-1.1,0.9l0,0 c-4.5,3.5-9.8,5.8-15.4,6.8c-1.9,1.3-4.2,2-6.5,2.1c0.5,0,1,0,1.4,0h0.3l1.3-0.1l0.6,0l0.7-0.1c0.5-0.1,0.9-0.1,1.3-0.2h0.2 c6.5-1,12.7-3.7,17.8-7.9C321.8,926.8,321.9,926.6,321.9,926.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.9,933.6c-0.4,0-0.8,0.1-1.2,0.1C300.1,933.7,300.5,933.6,300.9,933.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.8,933.7L296.8,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,933.7L298.8,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.7,919.9c-0.5,0.2-0.9,0.4-1.3,0.6c0.2,0.5,0.4,0.9,0.6,1.3c0.4-0.2,0.9-0.4,1.3-0.6 C284.1,920.8,283.9,920.4,283.7,919.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M311.9,921.3c0.5,0.2,0.9,0.4,1.3,0.6c0.2-0.4,0.4-0.9,0.6-1.3c-0.4-0.2-0.9-0.4-1.3-0.6 C312.3,920.4,312.1,920.8,311.9,921.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M294.7,933.5c-0.2,0-0.4,0-0.6-0.1C294.3,933.5,294.5,933.5,294.7,933.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.1,933.5l-0.6,0.1C301.7,933.5,301.9,933.5,302.1,933.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.5,933.7c-0.4,0-0.8,0-1.2-0.1C295.7,933.6,296,933.7,296.5,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,934.5v-0.8h-0.6h-0.3c-0.4,0-0.8,0-1.2-0.1l-0.5,0c-0.2,0-0.4,0-0.6-0.1c-0.9-0.1-1.7-0.2-2.6-0.4 c1.9,1.3,4.2,2,6.5,2.1C297.7,935.2,297.4,934.9,297.4,934.5C297.4,934.5,297.4,934.5,297.4,934.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.1,933.5c-0.2,0-0.4,0-0.6,0.1l-0.5,0c-0.4,0-0.8,0.1-1.2,0.1h-0.4h-0.6v0.8c0,0.4-0.3,0.7-0.7,0.7 c2.3,0,4.6-0.7,6.5-2.1C303.8,933.3,302.9,933.4,302.1,933.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,917.3h-0.7v1.5h0.7h0.7v-1.5H298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,933.7L298.1,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.4,933.7L297.4,933.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.8,934.5v-0.8h-1.5v0.8c0,0.4,0.3,0.7,0.7,0.7C298.5,935.2,298.8,934.9,298.8,934.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M639.7,388.2l4.3,0.8c0.8,3.8,2.3,7.4,4.4,10.7l-2.4,3.6c-0.9,1.4-0.8,3.2,0.4,4.3l3.2,3.2 c1.2,1.2,3,1.3,4.3,0.4l3.6-2.4c3.2,2.1,6.9,3.6,10.7,4.4l0.8,4.3c0.3,1.6,1.7,2.8,3.3,2.8h4.6c1.6,0,3-1.2,3.3-2.8l0.8-4.3 c3.8-0.8,7.4-2.3,10.7-4.4l3.6,2.4c1.4,0.9,3.2,0.8,4.3-0.4l3.2-3.2c1.2-1.2,1.3-3,0.4-4.3l-2.4-3.6c2.1-3.3,3.6-6.9,4.4-10.7 l4.3-0.8c1.6-0.3,2.8-1.7,2.8-3.4v-4.6c0-1.6-1.2-3-2.8-3.4l-4.3-0.8c-0.8-3.8-2.3-7.4-4.4-10.7l2.4-3.6c0.9-1.4,0.8-3.2-0.4-4.3 l-3.2-3.2c-1.2-1.2-3-1.3-4.3-0.4l-3.6,2.4c-3.3-2.1-6.9-3.6-10.7-4.4l-0.8-4.3c-0.3-1.6-1.7-2.8-3.3-2.8h-4.6 c-1.6,0-3,1.2-3.3,2.8l-0.8,4.3c-3.8,0.8-7.4,2.3-10.7,4.4l-3.6-2.4c-1.4-0.9-3.2-0.7-4.3,0.4l-3.2,3.2c-1.2,1.2-1.3,3-0.4,4.3 l2.5,3.6c-2.1,3.2-3.6,6.8-4.4,10.6l-4.3,0.8c-1.6,0.3-2.8,1.7-2.8,3.4v4.6C637,386.5,638.1,387.9,639.7,388.2z M638.4,380.3 c0-0.9,0.7-1.7,1.6-1.9l4.7-0.9c0.3-0.1,0.5-0.3,0.6-0.6c0.8-3.9,2.3-7.7,4.6-11c0.2-0.3,0.2-0.6,0-0.8l-2.7-4 c-0.5-0.8-0.4-1.8,0.2-2.5l3.2-3.2c0.7-0.7,1.7-0.8,2.5-0.2l4,2.7c0.3,0.2,0.6,0.2,0.8,0c3.3-2.3,7.1-3.8,11-4.6 c0.3-0.1,0.5-0.3,0.6-0.6l0.9-4.8c0.2-0.9,1-1.5,1.9-1.6h4.6c0.9,0,1.7,0.7,1.9,1.6l0.9,4.8c0,0.3,0.3,0.5,0.6,0.6 c3.9,0.8,7.7,2.3,11,4.6c0.3,0.2,0.6,0.2,0.8,0l4-2.7c0.8-0.5,1.8-0.4,2.5,0.2l3.2,3.2c0.7,0.7,0.7,1.7,0.2,2.5l-2.7,4 c-0.2,0.3-0.2,0.6,0,0.8c2.3,3.3,3.8,7.1,4.6,11c0.1,0.3,0.3,0.5,0.6,0.6l4.8,0.9c0.9,0.2,1.6,1,1.6,1.9v4.6c0,0.9-0.7,1.7-1.6,1.9 l-4.8,0.9c-0.3,0.1-0.5,0.3-0.6,0.6c-0.8,3.9-2.3,7.7-4.6,11c-0.2,0.3-0.2,0.6,0,0.8l2.7,4c0.5,0.8,0.4,1.8-0.2,2.5l-3.2,3.2 c-0.7,0.7-1.7,0.8-2.5,0.2l-4-2.7c-0.3-0.2-0.6-0.2-0.8,0c-3.3,2.3-7.1,3.8-11,4.6c-0.3,0.1-0.5,0.3-0.6,0.6l-0.9,4.8 c-0.2,0.9-1,1.6-1.9,1.6h-4.6c-0.9,0-1.7-0.7-1.9-1.6l-0.9-4.8c-0.1-0.3-0.3-0.5-0.6-0.6c-3.9-0.8-7.7-2.3-11-4.6 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1l-4,2.7c-0.8,0.5-1.8,0.4-2.5-0.2l-3.2-3.2c-0.6-0.7-0.7-1.7-0.2-2.5l2.7-4 c0.2-0.3,0.2-0.6,0-0.8c-2.3-3.3-3.8-7.1-4.6-11c-0.1-0.3-0.3-0.5-0.6-0.6l-4.7-0.9c-0.9-0.2-1.6-1-1.6-1.9L638.4,380.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M674.6,397.1c8,0,14.5-6.5,14.5-14.5c0-8-6.5-14.5-14.5-14.5c-8,0-14.5,6.5-14.5,14.5c0,0,0,0,0,0 C660.1,390.6,666.6,397.1,674.6,397.1z M674.6,369.6c7.2,0,13,5.8,13,13s-5.8,13-13,13s-13-5.8-13-13S667.4,369.6,674.6,369.6 L674.6,369.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "596.2,951.5 596.2,953.2 628.3,934.7 627.6,933.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M651.2,840c-0.4,0-0.7-0.3-0.7-0.7V884h1.5v-44.7C651.9,839.7,651.6,840,651.2,840z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M651.2,837.1c-0.4,0-0.7,0.3-0.7,0.7v1.5c0,0.4,0.2,0.8,0.6,0.8s0.8-0.2,0.8-0.6c0-0.1,0-0.1,0-0.2v-1.5 C651.9,837.4,651.6,837.1,651.2,837.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M595.1,952.2c-0.4,0.2-0.5,0.6-0.3,1c0.1,0.2,0.4,0.4,0.7,0.4c0.1,0,0.3,0,0.4-0.1l0.4-0.2v-1.7L595.1,952.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M651.6,921.3l-23.2,13.4l0.9,1.6l23.3-13.4c0.8-0.5,1.3-1.3,1.3-2.2V884h-1.8v36.7 C651.9,920.9,651.8,921.2,651.6,921.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "650.5,884 648.6,884 648.6,919.2 626.7,931.8 627.6,933.4 650.5,920.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M650.5,920.2l-22.9,13.2l0.7,1.3l23.2-13.4c0.2-0.1,0.4-0.4,0.4-0.6V884h-1.5V920.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M714.6,559.8v-53.3c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.7-0.1v53.3c0,2.9-1.6,5.6-4.1,7l-13.9,8 c-3,1.7-4.8,4.9-4.8,8.3v65c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7,0.1v-65c0-2.9,1.6-5.6,4.1-7l13.9-8 C712.8,566.4,714.6,563.3,714.6,559.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M713.9,503.3c0.4,0,0.7,0.3,0.7,0.7v2.5c1.4-0.4,2.2-1.9,1.7-3.2c-0.4-1.4-1.9-2.2-3.2-1.7s-2.2,1.9-1.7,3.2 c0.2,0.8,0.9,1.5,1.7,1.7v-2.5C713.2,503.6,713.5,503.3,713.9,503.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M714.6,506.5V504c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v2.5c0.2,0.1,0.5,0.1,0.7,0.1 C714.1,506.6,714.4,506.6,714.6,506.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M691.2,651.4c-0.4,0-0.7-0.3-0.7-0.7v-2.5c-1.4,0.4-2.2,1.9-1.7,3.2s1.9,2.2,3.2,1.7c1.4-0.4,2.2-1.9,1.7-3.2 c-0.2-0.8-0.9-1.5-1.7-1.7v2.5C691.9,651.1,691.6,651.4,691.2,651.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M690.4,648.2v2.5c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-2.5c-0.2-0.1-0.5-0.1-0.7-0.1 C690.9,648.1,690.6,648.1,690.4,648.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.3,622.1c-0.3,0-0.5-0.2-0.5-0.5v-3.3c-1.4,0.3-2.3,1.7-2,3.1c0.3,1.4,1.7,2.3,3.1,2s2.3-1.7,2-3.1 c-0.2-1-1-1.8-2-2v3.3C437.8,621.8,437.6,622.1,437.3,622.1C437.3,622.1,437.3,622.1,437.3,622.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M436.7,618.2v3.3c0,0.3,0.3,0.5,0.6,0.5c0.3,0,0.4-0.2,0.5-0.5v-3.3c-0.2,0-0.4-0.1-0.6-0.1 C437.1,618.1,436.9,618.2,436.7,618.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.3,841.3c0.3,0,0.6,0.2,0.6,0.5v2.9c1.4-0.3,2.3-1.7,1.9-3.1c-0.3-1.4-1.7-2.3-3.1-1.9s-2.3,1.7-1.9,3.1 c0.2,1,1,1.7,1.9,1.9v-3C436.8,841.6,437,841.3,437.3,841.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.8,844.8v-2.9c0-0.3-0.3-0.5-0.6-0.5c-0.3,0-0.4,0.2-0.5,0.5v3c0.2,0,0.4,0.1,0.5,0.1 C437.5,844.9,437.6,844.9,437.8,844.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,976.3c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,977,649.9,976.3,649,976.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,989.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,990.7,649.9,989.9,649,989.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,1003.6c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,1004.3,649.9,1003.6,649,1003.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,1017.2c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,1018,649.9,1017.2,649,1017.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,1030.9c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,1031.6,649.9,1030.9,649,1030.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,1044.5c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,1045.3,649.9,1044.5,649,1044.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649,1058.2c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C650.6,1058.9,649.9,1058.2,649,1058.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.5,672.1l-0.2,0.2l-0.9,0.5v399h1.1V672.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156,671c-0.3,0-0.6,0.3-0.6,0.6v1.2l0.9-0.5l0.2-0.2v-0.5C156.6,671.3,156.3,671,156,671z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "849.3,498.2 848.6,499.5 868,510.7 868,509  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823.3,
    y: 315.7,
    className: "st6",
    width: 1.5,
    height: 94.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M823.3,484.5v-74.2h-1.8v74.1c0,0.9,0.5,1.8,1.3,2.2l24.9,14.4l0.9-1.6l-24.9-14.4 C823.5,485,823.3,484.7,823.3,484.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "826.7,483 826.7,410.3 824.8,410.3 824.8,484.1 849.3,498.2 850.3,496.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.8,410.3h-1.5v74.1c0,0.3,0.1,0.5,0.4,0.6l24.9,14.4l0.7-1.3l-24.5-14.2V410.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 824.1,
    cy: 536.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.1,548.6c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C825.7,549.4,825,548.6,824.1,548.6C824.1,548.6,824.1,548.6,824.1,548.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 824.1,
    cy: 563.8,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.1,575.6c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C825.7,576.4,825,575.6,824.1,575.6C824.1,575.6,824.1,575.6,824.1,575.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.1,589.1c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0C825.7,589.9,825,589.1,824.1,589.1 C824.1,589.1,824.1,589.1,824.1,589.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 824.1,
    cy: 604.3,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.1,616.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0C825.7,616.9,825,616.2,824.1,616.2 C824.1,616.1,824.1,616.1,824.1,616.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.1,629.7c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C825.7,630.4,825,629.7,824.1,629.7C824.1,629.7,824.1,629.7,824.1,629.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.6,
    y: 542.6,
    className: "st6",
    width: 1.8,
    height: 83.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 751.3,
    y: 542.6,
    className: "st6",
    width: 1.8,
    height: 83.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M754.4,991.3l68.9-39.8v-1.7l-70,40.4c-0.2,0.1-0.4,0.4-0.4,0.6v71.4l1.1,0.6c0.4,0.2,0.5,0.7,0.3,1 c-0.1,0.2-0.4,0.4-0.6,0.4c-0.1,0-0.3,0-0.4-0.1l-0.3-0.3v7.7h1.5L754.4,991.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.4,950.9c0.4-0.2,0.5-0.7,0.3-1s-0.7-0.5-1-0.3l-0.4,0.2v1.7L824.4,950.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M765.4,755.9c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2L765.4,755.9z M765.1,770.7c-1,1-2.7,1-3.7,0 l-7.2-7.2l7.2-7.3c1-1,2.7-1,3.7,0l7.2,7.3L765.1,770.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M763.3,774.4C763.3,774.4,763.3,774.4,763.3,774.4c-1.5,0-2.9-0.6-3.9-1.6l-7.4-7.4c-0.4-0.4-0.6-0.8-0.7-1.3 l-0.6-0.6l0.6-0.6c0.1-0.5,0.4-1,0.7-1.3l7.4-7.4c1.1-1,2.4-1.6,3.9-1.6c1.5,0,2.8,0.6,3.9,1.6l7.4,7.4c0.4,0.4,0.6,0.8,0.7,1.3 l0.6,0.6l-0.6,0.6c-0.1,0.5-0.4,0.9-0.7,1.3l-7.4,7.4C766.1,773.8,764.7,774.4,763.3,774.4z M757.7,763.4l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L757.7,763.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M765.4,784.5c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2L765.4,784.5z M765.1,799.3c-1,1-2.7,1-3.7,0 l-7.2-7.3l7.2-7.3c1-1,2.7-1,3.7,0l7.2,7.3L765.1,799.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M763.3,803C763.3,803,763.3,803,763.3,803c-1.5,0-2.9-0.6-3.9-1.6l-7.4-7.4c-0.4-0.4-0.6-0.8-0.7-1.3 l-0.6-0.6l0.6-0.6c0.1-0.5,0.4-0.9,0.7-1.3l7.5-7.5c1-1,2.4-1.5,3.8-1.5c1.5,0,2.8,0.6,3.9,1.6l7.4,7.4c0.3,0.3,0.6,0.8,0.7,1.3 l0.6,0.6l-0.6,0.6c-0.1,0.5-0.4,1-0.8,1.4l-7.5,7.5C766.1,802.4,764.7,803,763.3,803z M757.7,792l5.5,5.5c0,0,0.1,0,0.2,0l5.5-5.5 l-5.5-5.5c0,0-0.1,0-0.2,0L757.7,792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M765.4,813.1c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.1L765.4,813.1z M765.1,827.9c-1,1-2.7,1-3.7,0 l-7.2-7.2l7.2-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.2,7.2L765.1,827.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M763.3,831.6C763.3,831.6,763.3,831.6,763.3,831.6c-1.5,0-2.9-0.6-3.9-1.6l-7.4-7.4c-0.4-0.4-0.6-0.8-0.7-1.3 l-0.6-0.6l0.6-0.6c0.1-0.5,0.4-1,0.8-1.3l7.4-7.4c1.1-1.1,2.5-1.6,3.9-1.6c0,0,0,0,0.1,0c1.5,0,2.8,0.6,3.9,1.6l7.4,7.4 c0.4,0.4,0.6,0.8,0.8,1.3l0.6,0.6l-0.6,0.6c-0.1,0.5-0.4,0.9-0.7,1.3l-7.4,7.4C766.1,831,764.7,831.6,763.3,831.6z M757.7,820.6 l5.5,5.5c0,0,0.1,0,0.2,0l5.5-5.5l-5.5-5.5c-0.1-0.1-0.1-0.1-0.2,0L757.7,820.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M765.4,841.7c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.1L765.4,841.7z M765.1,856.5c-1,1-2.7,1-3.7,0 l-7.2-7.2l7.2-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.2,7.2L765.1,856.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M763.3,860.2C763.3,860.2,763.3,860.2,763.3,860.2c-1.5,0-2.9-0.6-3.9-1.6l-7.4-7.4c-0.4-0.4-0.6-0.8-0.7-1.3 l-0.6-0.6l0.6-0.6c0.1-0.5,0.4-1,0.8-1.4l7.4-7.4c1-1,2.4-1.5,3.8-1.5c1.5,0,2.8,0.6,3.9,1.6l7.4,7.4c0.4,0.3,0.6,0.8,0.7,1.3 l0.6,0.6l-0.6,0.6c-0.1,0.5-0.4,0.9-0.7,1.3l-7.4,7.4C766.1,859.6,764.7,860.2,763.3,860.2z M757.7,849.2l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L757.7,849.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M765.4,870.3c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.1l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.1L765.4,870.3z M765.1,885.1c-1,1-2.7,1-3.7,0 l-7.2-7.2l7.2-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.2,7.2L765.1,885.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M763.3,888.8C763.3,888.8,763.3,888.8,763.3,888.8c-1.5,0-2.9-0.6-3.9-1.6l-7.4-7.4c-0.4-0.4-0.6-0.8-0.7-1.3 l-0.6-0.6l0.6-0.6c0.1-0.5,0.4-1,0.7-1.3l7.4-7.4c1.1-1.1,2.5-1.7,4-1.6c1.5,0,2.8,0.6,3.9,1.6l7.4,7.4c0.4,0.4,0.6,0.8,0.7,1.3 l0.6,0.6l-0.6,0.6c-0.1,0.5-0.4,0.9-0.7,1.3l-7.5,7.5C766.1,888.2,764.7,888.8,763.3,888.8z M757.7,877.8l5.5,5.5c0,0,0.1,0,0.2,0 l5.5-5.5l-5.5-5.5c0,0-0.1,0-0.2,0L757.7,877.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M765.4,898.9c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0l-7.4,7.4c-0.1,0.1-0.1,0.2,0,0.3c0,0,0,0,0,0l7.4,7.4 c1.2,1.2,3.1,1.2,4.2,0c0,0,0,0,0,0l7.4-7.4c0.1-0.1,0.1-0.2,0-0.3c0,0,0,0,0,0L765.4,898.9z M765.1,913.7c-1,1-2.7,1-3.7,0 l-7.2-7.2l7.2-7.2c1-1,2.7-1,3.7,0c0,0,0,0,0,0l7.2,7.2L765.1,913.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M763.3,917.4C763.3,917.4,763.3,917.4,763.3,917.4c-1.5,0-2.9-0.6-3.9-1.6l-7.6-7.6c-0.3-0.3-0.4-0.7-0.5-1.1 l-0.6-0.6l0.6-0.6c0.1-0.5,0.4-0.9,0.7-1.3l7.4-7.4c2.2-2.2,5.7-2.1,7.8,0l7.5,7.5c0.3,0.3,0.5,0.8,0.6,1.2l0.6,0.6l-0.6,0.6 c-0.1,0.5-0.4,1-0.8,1.4l-7.4,7.4C766.1,916.8,764.7,917.4,763.3,917.4z M757.7,906.4l5.5,5.5c0,0,0.1,0,0.2,0l5.5-5.5l-5.5-5.5 c-0.1-0.1-0.1-0.1-0.2,0L757.7,906.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "155.2,533.7 112,508.7 112,510.4 155.2,535.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M155.6,535.6c0.1,0.1,0.2,0.1,0.4,0.1c0.3,0,0.5-0.1,0.6-0.4c0.2-0.3,0.1-0.8-0.3-1c0,0,0,0,0,0l-1.1-0.6v1.7 L155.6,535.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M754.1,418l-1,0.6v124h1.5V417.4c0-0.2,0-0.3-0.1-0.4v0.4C754.4,417.6,754.3,417.9,754.1,418z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M753.1,675.2l-51,29.4c-0.2,0.1-0.4,0.4-0.4,0.6v328.8c0,0.3,0.1,0.5,0.4,0.6L753,1064v-1.7l-49.7-28.7v-328 l50.9-29.4c0.2-0.1,0.4-0.4,0.4-0.6v-49.6h-1.5V675.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M753.8,416.6c-0.4,0-0.7,0.3-0.7,0.7v1.2l1-0.6c0.2-0.1,0.4-0.4,0.4-0.6V417 C754.3,416.8,754.1,416.6,753.8,416.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 753.1,
    y: 542.6,
    className: "st6",
    width: 1.5,
    height: 83.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M753.3,1064.3c0.1,0.1,0.2,0.1,0.4,0.1c0.4,0,0.7-0.3,0.7-0.7c0-0.3-0.1-0.5-0.4-0.6l-1.1-0.6v1.7 L753.3,1064.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,537.9c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6 C541.1,537.1,541.9,537.9,542.8,537.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M542.8,548c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0 C544.4,548.8,543.7,548.1,542.8,548z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M865.5,755c0,1.2,0.8,2.2,2,2.5v-1.4c0-0.3,0.2-0.6,0.5-0.6v-3.2C866.6,752.4,865.5,753.6,865.5,755z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M868,757.6c-0.2,0-0.4,0-0.5-0.1v314.2h0.5V757.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M868,755.6c-0.3,0-0.6,0.3-0.5,0.6v1.4c0.2,0,0.4,0.1,0.5,0.1V755.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112.5,756.2v1.4c1.4-0.3,2.3-1.6,2-3c-0.2-1.2-1.3-2.1-2.6-2.1v3.2C112.3,755.6,112.5,755.9,112.5,756.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112,757.6v314.1h0.6V757.6C112.4,757.6,112.2,757.6,112,757.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112,755.6v2c0.2,0,0.4,0,0.6-0.1v-1.4C112.6,755.9,112.3,755.6,112,755.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112,448.8c0.2,0,0.4,0,0.6,0.1V315.7H112V448.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.6,451.4c0-1.2-0.8-2.3-2-2.5v2.1c0,0.3-0.2,0.6-0.6,0.6v2.4C113.4,454,114.6,452.8,114.6,451.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112,451.6c0.3,0,0.6-0.3,0.6-0.6v-2.1c-0.2,0-0.4-0.1-0.6-0.1V451.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M868,448.8V315.7h-0.5v133.2C867.7,448.8,867.9,448.8,868,448.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M867.5,451v-2.1c-1.4,0.3-2.3,1.7-2,3.1c0.3,1.2,1.3,2,2.5,2v-2.4C867.7,451.6,867.5,451.3,867.5,451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M868,451.6v-2.8c-0.2,0-0.4,0-0.5,0.1v2.1C867.5,451.3,867.7,451.6,868,451.6C868,451.6,868,451.6,868,451.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumiasCard);
export default __webpack_public_path__ + "static/media/Lumias_card.880aa65c815ae73f5339b67035f2d41d.svg";
export { ForwardRef as ReactComponent };